// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-Popup-styles___dialogBox--ut1lZ {
  min-width: 540px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___title--QHcuf {
    font-size: 29px;
    color: #1b2432;
    background-color: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex: 1 0 auto;
    padding: 32px 32px 0;
  }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___title--QHcuf .components-Popup-styles___closeIcon--ONXRt {
      top: 22px;
      right: 21px;
      position: absolute;
      width: -moz-fit-content !important;
      width: fit-content !important;
    }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___title--QHcuf .components-Popup-styles___closeIcon--ONXRt .components-Popup-styles___svg--lywVS {
        font-size: 26px;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___title--QHcuf .components-Popup-styles___closeIconCreditCard--jNfbX {
      top: 22px;
      right: 21px;
      position: absolute;
      width: -moz-fit-content !important;
      width: fit-content !important;
    }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___title--QHcuf .components-Popup-styles___closeIconCreditCard--jNfbX .components-Popup-styles___svg--lywVS {
        font-size: 26px;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___title--QHcuf .components-Popup-styles___closeIconPopupAdd--ufESM {
      top: 22px;
      right: 15px;
      position: absolute;
    }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___title--QHcuf .components-Popup-styles___closeIconPopupAdd--ufESM .components-Popup-styles___svg--lywVS {
        font-size: 26px;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___title--QHcuf .components-Popup-styles___closeIconPopupAdd--ufESM {
      top: 22px;
      right: 15px;
      position: absolute;
    }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___title--QHcuf .components-Popup-styles___closeIconPopupAdd--ufESM .components-Popup-styles___svg--lywVS {
        font-size: 26px;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___flightDetails--zBMOp {
    min-width: 700px;
  }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin: 32px;
      margin-bottom: 0px;
      padding-bottom: 32px;
      border-bottom: 1px solid #e0e2e6;
    }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___destinations--fwfJl {
        font-size: 25px;
        color: #1b2432;
        letter-spacing: 0;
        min-width: 180px;
        align-self: center;
        display: flex;
        align-items: center;
        font-weight: 300;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___destinations--fwfJl p {
          margin-bottom: 10px;
        }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___destinations--fwfJl svg:first-child {
          margin: 0 20px;
          margin-right: 0;
        }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___destinations--fwfJl .components-Popup-styles___svgLoc--B50qG {
          margin-right: 15px;
          margin-left: 0;
        }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___destinations--fwfJl .components-Popup-styles___svgLoc--B50qG svg {
            margin-left: 5px;
          }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___destinations--fwfJl .components-Popup-styles___line--JO4Yw {
          width: 497px;
          margin-left: auto;
          margin-right: auto;
          height: 2px;
          background-color: #318afb;
          margin-bottom: 7px;
        }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___locationFrom--rRN1k {
        text-align: left;
        width: 33%;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___time--GCELg {
        width: 33%;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___locationTo--n6Coh {
        text-align: right;
        width: 33%;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___locationTo--n6Coh .components-Popup-styles___redColor--AEMnU {
          color: #fc3b60 !important;
        }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___destinationDetails--Uke9q {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 7px;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___destinationDetails--Uke9q .components-Popup-styles___labels--oAqPI {
          font-size: 15px;
          color: #5f6670;
          letter-spacing: 0;
        }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___destinationDetails--Uke9q div p {
          font-size: 15px;
          color: #5f6670;
          letter-spacing: 0;
          margin: 4px 0;
        }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___seatDetails--pJPqe {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___seatDetails--pJPqe div {
          text-align: left;
          margin-right: 60px;
        }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___seatDetails--pJPqe .components-Popup-styles___subTitle--Sb7F2 {
          font-size: 15px;
          color: #5f6670;
          letter-spacing: 0;
          margin-bottom: 5px;
        }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___seatDetails--pJPqe .components-Popup-styles___logo--max0A {
          height: 32px;
          width: 32px;
          border-radius: 50%;
          border: 1px solid #dddee0;
          margin-right: 20px;
        }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___seatDetails--pJPqe .components-Popup-styles___logo--max0A img {
            height: 30px;
            width: auto;
            border-radius: 50%;
          }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___travelerDetailsListContainer--WR93m {
        margin: 12px 0;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___travelerDetails--Z6RvL {
        border: 1px solid #edeeef;
        border-radius: 4px;
        font-size: 15px;
        color: #1b2432;
        letter-spacing: 0;
        min-height: 66px;
        margin: 12px 0;
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: flex-start;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___travelerDetails--Z6RvL p {
          margin-bottom: auto;
          margin-top: auto;
        }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___travelerDetails--Z6RvL .components-Popup-styles___travelerName--ynl4b {
          margin-right: 45px;
          margin-left: 20px;
          font-size: 15px;
          color: #1b2432;
          letter-spacing: 0;
        }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___amenities--TVrUO {
        background: #f4f4f5;
        letter-spacing: 0;
        border-bottom: none;
        font-size: 13px;
        padding: 0 16px;
        color: #6d717a;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___amenities--TVrUO .components-Popup-styles___amenities--TVrUO {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #e0e2e6;
          padding: 0;
        }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___amenities--TVrUO .components-Popup-styles___amenities--TVrUO p {
            margin: 16px 0;
          }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___amenities--TVrUO .components-Popup-styles___amenities--TVrUO .components-Popup-styles___amenitiesIcon--QMjE5 svg {
              margin: 0 10px;
            }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___amenities--TVrUO .components-Popup-styles___amenities--TVrUO .components-Popup-styles___amenitiesIcon--QMjE5 svg:last-of-type {
              margin-right: 0px;
            }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___amenities--TVrUO .components-Popup-styles___baggage--TvGeH {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___details--f7baD {
        font-size: 15px;
        color: #5f6670;
        letter-spacing: 0;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___labels--oAqPI {
        font-size: 11px;
        color: #6d717a;
        letter-spacing: 0;
        margin-bottom: 8px;
        margin-top: 0;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___body--PXfWk .components-Popup-styles___container--Wfpsn .components-Popup-styles___airline--oCyto {
        margin-bottom: 0;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___rateCode--SapHR {
    min-width: 700px;
    text-align: right;
    padding: 0 32px;
    padding-bottom: 32px;
  }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___rateCode--SapHR .components-Popup-styles___inputWrapperContainer--n0MLE {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___rateCode--SapHR .components-Popup-styles___inputWrapper--lIUVf {
      margin-top: 8px;
      margin-bottom: 26px;
      flex: 49% 0 1;
      padding: 8px 0 0;
    }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___rateCode--SapHR .components-Popup-styles___inputContainer--kkkNC {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding-bottom: 12px;
    }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___rateCode--SapHR .components-Popup-styles___inputContainer--kkkNC .components-Popup-styles___inputWrapper--lIUVf {
        flex: 49% 0 1;
        padding: 8px 0 0;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___rateCode--SapHR .components-Popup-styles___button--WBGDM {
      height: 52px;
      width: 150px;
      padding: 0;
    }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___content--Kz7JJ {
    margin: 22px 32px 32px;
    max-width: 537px;
  }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___content--Kz7JJ .components-Popup-styles___textField--ThYmS {
      margin: 15px 0 10px 0 !important;
    }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___content--Kz7JJ .components-Popup-styles___textField--ThYmS button {
        padding: 0 !important;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___content--Kz7JJ .components-Popup-styles___button--WBGDM {
      font-weight: normal;
      text-transform: capitalize;
      width: 200px;
      padding: 0;
    }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___content--Kz7JJ .components-Popup-styles___file-name--lm52V {
      text-align: left;
      font-size: 14px;
      margin: 35px 0 10px 0;
      padding-bottom: 10px;
      border-bottom: 1px solid #e0e2e6;
    }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___content--Kz7JJ .components-Popup-styles___file-name--lm52V::after {
        content: ' ';
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___content--Kz7JJ .components-Popup-styles___actions--WG6h7 {
      display: flex;
      min-width: 500px;
      text-align: left;
      align-items: center;
      margin: 20px 0;
      justify-content: flex-end;
    }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___content--Kz7JJ .components-Popup-styles___actions--WG6h7 .components-Popup-styles___download-link--us4lS,
      .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___content--Kz7JJ .components-Popup-styles___actions--WG6h7 .components-Popup-styles___button--WBGDM {
        flex: 1 0 0;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___content--Kz7JJ .components-Popup-styles___actions--WG6h7 .components-Popup-styles___download-link--us4lS {
        font-size: 13px;
        color: #6d717a;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___content--Kz7JJ .components-Popup-styles___actions--WG6h7 .components-Popup-styles___download-link--us4lS > a {
          color: #318afb;
        }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___content--Kz7JJ .components-Popup-styles___actions--WG6h7 .components-Popup-styles___button--WBGDM {
        text-align: right;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___content--Kz7JJ .components-Popup-styles___actions--WG6h7 .components-Popup-styles___buttonDelete--CgpPh {
        color: #fc3b60 !important;
        border: 1px solid #fc3b60;
        width: 142px;
        height: 32px;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___content--Kz7JJ .components-Popup-styles___actionsBetween--TsV4a {
      justify-content: space-between;
      align-items: flex-end;
    }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___content--Kz7JJ .components-Popup-styles___actionsBetween--TsV4a .components-Popup-styles___button--WBGDM {
        flex: 0 1 200px;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___content--Kz7JJ .components-Popup-styles___actions-right--Zh9QO {
      justify-content: flex-end;
    }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___content--Kz7JJ .components-Popup-styles___actions-right--Zh9QO .components-Popup-styles___button--WBGDM {
        flex: 0 1 200px;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___content--Kz7JJ .components-Popup-styles___actionsRight--_q9Qv {
      justify-content: flex-end;
      margin: 20px 0 0;
      display: flex;
    }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___content--Kz7JJ .components-Popup-styles___actionsRight--_q9Qv .components-Popup-styles___button--WBGDM {
        flex: 0 1 200px;
      }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___content--Kz7JJ .components-Popup-styles___error-message--Z1ATD {
      font-size: 12px;
      text-align: left;
      color: #ff0000;
    }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___content--Kz7JJ .components-Popup-styles___error-file-name--gt5Ig {
      border-bottom: 1px solid #ff0000;
    }

  .components-Popup-styles___dialogBox--ut1lZ.components-Popup-styles___changePasswordBox--ARWal .components-Popup-styles___content--Kz7JJ {
      max-width: 336px;
      margin: 10px 32px 32px;
    }

  .components-Popup-styles___dialogBox--ut1lZ.components-Popup-styles___changePasswordBox--ARWal .components-Popup-styles___textField--ThYmS {
      margin: 18px 0 14px !important;
    }

  .components-Popup-styles___dialogBox--ut1lZ.components-Popup-styles___changePasswordBox--ARWal .components-Popup-styles___button--WBGDM {
      width: 100%;
      margin: 18px 0 0 !important;
    }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___icon--attu7 {
    width: 19px;
    height: 19px;
  }

  .components-Popup-styles___dialogBox--ut1lZ .components-Popup-styles___eyeVisible--hU7PT {
    fill: #318afb;
  }

  .components-Popup-styles___dialogBox--ut1lZ.components-Popup-styles___confirmationDialog--eLcPK .components-Popup-styles___title--QHcuf {
      font-size: 19px;
      color: #1b2432;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1 0 auto;
      padding: 32px 0 0;
    }

  .components-Popup-styles___dialogBox--ut1lZ.components-Popup-styles___confirmationDialog--eLcPK .components-Popup-styles___title--QHcuf.components-Popup-styles___bookingErrorPopupTitle--zyDzr {
        min-width: 400px;
      }

  .components-Popup-styles___dialogBox--ut1lZ.components-Popup-styles___confirmationDialog--eLcPK .components-Popup-styles___body--PXfWk {
      color: #6d717a;
      font-size: 15px;
      padding: 36px;
      padding-top: 15px;
      max-width: 450px;
      padding-bottom: 48px;
    }

  .components-Popup-styles___dialogBox--ut1lZ.components-Popup-styles___confirmationDialog--eLcPK .components-Popup-styles___confBody--Vq1f6 {
      color: #6d717a;
      font-size: 15px;
      padding: 36px;
      padding-top: 15px;
      max-width: 450px;
    }

  .components-Popup-styles___dialogBox--ut1lZ.components-Popup-styles___confirmationDialog--eLcPK .components-Popup-styles___bookingErrorPopupContent--RjBCr {
      margin: 10px 20px 24px;
    }

  .components-Popup-styles___dialogBox--ut1lZ.components-Popup-styles___confirmationDialog--eLcPK .components-Popup-styles___bookingErrorPopupContent--RjBCr .components-Popup-styles___bookingErrorPrimaryButton--_ArHX {
        width: 100%;
      }

  .components-Popup-styles___dialogBox--ut1lZ.components-Popup-styles___flightDetails--zBMOp {
    min-width: 540px;
  }

  .components-Popup-styles___dialogBox--ut1lZ.components-Popup-styles___roomDetailsDialog--jgT9k .components-Popup-styles___content--Kz7JJ {
      margin: 32px;
    }

  .components-Popup-styles___dialogBox--ut1lZ.components-Popup-styles___roomDetailsDialog--jgT9k .components-Popup-styles___buttonContent--TsnIA {
      margin: 0 32px 32px;
      text-align: right;
    }

  .components-Popup-styles___dialogBox--ut1lZ.components-Popup-styles___sendEmailConfirmation--gVYO_ .components-Popup-styles___content--Kz7JJ {
      max-width: 637px !important;
    }

  .components-Popup-styles___dialogBox--ut1lZ.components-Popup-styles___sendEmailConfirmation--gVYO_ .components-Popup-styles___content--Kz7JJ .components-Popup-styles___sendEmailText--j8LUa {
        font-size: 15px;
        color: #6d717a;
        letter-spacing: 0;
        text-align: left;
        line-height: 38px;
      }

  .components-Popup-styles___dialogBox--ut1lZ.components-Popup-styles___sendEmailConfirmation--gVYO_ .components-Popup-styles___content--Kz7JJ .components-Popup-styles___additionalEmailsText--YtdYY {
        font-size: 15px;
        color: #6d717a;
        letter-spacing: 0;
        text-align: left;
        line-height: 38px;
        font-weight: 600;
      }

  .components-Popup-styles___dialogBox--ut1lZ.components-Popup-styles___ccPopup--yCVOX .components-Popup-styles___title--QHcuf {
      font-size: 29px;
      color: #1b2432;
      background-color: #fff;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex: 1 0 auto;
      padding: 32px 32px 0;
    }

  .components-Popup-styles___dialogBox--ut1lZ.components-Popup-styles___ccPopup--yCVOX .components-Popup-styles___subtitle--I1rz1 {
      color: #6d717a;
      font-size: 15px;
      padding: 8px 32px 16px;
      text-align: left;
    }

  .components-Popup-styles___dialogBox--ut1lZ.components-Popup-styles___ccPopup--yCVOX .components-Popup-styles___deleteWrapper--L4V4n {
      border-bottom: 1px solid #e0e2e6;
      padding: 8px 0 16px;
      text-align: left;
    }

  .components-Popup-styles___dialogBox--ut1lZ.components-Popup-styles___ccPopup--yCVOX .components-Popup-styles___buttonDelete--CgpPh {
      color: #fc3b60 !important;
      height: 32px;
    }

  .components-Popup-styles___dialogBox--ut1lZ.components-Popup-styles___ccPopup--yCVOX .components-Popup-styles___actionsCC--YA3FN {
      justify-content: flex-end;
      margin: 32px 0 22px;
    }

  .components-Popup-styles___dialogBox--ut1lZ.components-Popup-styles___ccPopup--yCVOX .components-Popup-styles___actionsCC--YA3FN .components-Popup-styles___button--WBGDM {
        max-width: 150px;
      }

  .components-Popup-styles___dialogBox--ut1lZ.components-Popup-styles___ccPopup--yCVOX .components-Popup-styles___selectWrapper--Q39OA {
      width: 100%;
      margin-top: 24px;
    }

.components-Popup-styles___travelPolicyDialogBox--fYL66 {
  text-align: left;
}

.components-Popup-styles___travelPolicyDialogBox--fYL66 .components-Popup-styles___policyRow--Twd5W {
    padding: 32px 0;
    border-bottom: 1px solid #e0e2e6;
    display: flex;
    align-items: center;
    font-size: 15px;
  }

.components-Popup-styles___travelPolicyDialogBox--fYL66 .components-Popup-styles___policyRow--Twd5W .components-Popup-styles___policyDescription--yF_Nm {
      flex: 1;
      color: #6d717a;
      font-size: 13px;
    }

.components-Popup-styles___travelPolicyDialogBox--fYL66 .components-Popup-styles___policyRow--Twd5W .components-Popup-styles___policyDescription--yF_Nm .components-Popup-styles___policyTitle--sXwu4 {
        font-size: 15px;
        font-weight: 500;
        line-height: 18px;
        padding-bottom: 6px;
        color: #1b2432;
      }

.components-Popup-styles___travelPolicyDialogBox--fYL66 .components-Popup-styles___policyRow--Twd5W .components-Popup-styles___policyDescription--yF_Nm .components-Popup-styles___policyText--xhKAM {
        max-width: 300px;
      }

.components-Popup-styles___travelPolicyDialogBox--fYL66 .components-Popup-styles___policyRow--Twd5W .components-Popup-styles___policyValue--vZy1m {
      min-width: 80px;
      padding: 0 5px;
      height: 44px;
      border: 1px solid #12da9f;
      border-radius: 6px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(18, 218, 159, 0.1);
      font-weight: 700;
    }

.components-Popup-styles___travelPolicyDialogBox--fYL66 .components-Popup-styles___content--Kz7JJ {
    max-width: initial;
    overflow-y: auto;
    margin-right: 0px;
    padding-right: 20px;
  }

.components-Popup-styles___travelPolicyDialogBox--fYL66 .components-Popup-styles___content--Kz7JJ .components-Popup-styles___actions-right--Zh9QO {
      margin: 32px 0 22px;
      min-width: 660px;
    }

.components-Popup-styles___travelPolicyDialogBox--fYL66 .components-Popup-styles___content--Kz7JJ .components-Popup-styles___actions-right--Zh9QO .components-Popup-styles___button--WBGDM {
        flex: 0 1 144px;
      }

.components-Popup-styles___radioGroup--ohQ3j {
  padding: 0 32px;
}

.components-Popup-styles___radioGroupLabel--NlM7M {
  font-weight: 400;
}

.components-Popup-styles___subtitlePopup--SshBO {
  max-width: 611px;
  color: #6d717a;
  font-size: 15px;
  text-align: left;
  padding: 16px 0 0 32px;
  font-family: 'Roboto';
  line-height: 18px;
}

.components-Popup-styles___updatePopup--cO1mT {
  padding: 32px;
  max-width: 700px;
  margin: 0 0 30px;
  padding-top: 0px;
  padding-bottom: 0px;
  font-family: 'Roboto';
}

.components-Popup-styles___updatePopup--cO1mT .components-Popup-styles___informationTitle--_QZhx {
    font-size: 17px;
    color: #1b2432;
    letter-spacing: 0;
    font-family: 'Roboto-Medium', 'Roboto', sans-serif;
  }

.components-Popup-styles___updatePopup--cO1mT .components-Popup-styles___addMarginTop--QYPTY {
    margin-top: 16px;
  }

.components-Popup-styles___updatePopup--cO1mT .components-Popup-styles___billingAddress--NyvXN {
    font-size: 15px;
    color: #318afb;
    letter-spacing: 0;
    text-align: right;
  }

.components-Popup-styles___updatePopup--cO1mT .components-Popup-styles___billingAddressContainer--f8wHR {
    display: flex;
    justify-content: space-between;
  }

.components-Popup-styles___updatePopup--cO1mT .components-Popup-styles___inputContainer--kkkNC {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-bottom: 22px;
  }

.components-Popup-styles___updatePopup--cO1mT .components-Popup-styles___inputContainer--kkkNC.components-Popup-styles___passportInfo--E4UqH {
      padding-bottom: 24px;
    }

.components-Popup-styles___updatePopup--cO1mT .components-Popup-styles___inputContainer--kkkNC.components-Popup-styles___inputContainerTravelerSelection--D5oRQ {
      padding: 16px 0 0;
      border-bottom: none;
    }

.components-Popup-styles___updatePopup--cO1mT .components-Popup-styles___inputContainer--kkkNC.components-Popup-styles___inputContainerTravelerSelectionOpen--qEtK5 {
      padding: 0 0 32px 0;
    }

.components-Popup-styles___updatePopup--cO1mT .components-Popup-styles___inputContainer--kkkNC.components-Popup-styles___wrapperContainer--Gxw2v {
      border-top: 1px solid #dddee0;
      flex-direction: column;
      padding-top: 32px;
    }

.components-Popup-styles___updatePopup--cO1mT .components-Popup-styles___inputContainer--kkkNC.components-Popup-styles___wrapperContainer--Gxw2v .components-Popup-styles___subtitle--I1rz1 {
        color: #6d717a;
        font-size: 15px;
        padding: 6px 0 16px;
      }

.components-Popup-styles___updatePopup--cO1mT .components-Popup-styles___inputContainer--kkkNC.components-Popup-styles___wrapperContainer--Gxw2v .components-Popup-styles___radioGroupLabel--NlM7M {
        font-weight: 400;
      }

.components-Popup-styles___updatePopup--cO1mT .components-Popup-styles___inputWrapper--lIUVf {
    flex: 49% 0 1;
    padding: 8px 0 0;
  }

.components-Popup-styles___updatePopup--cO1mT .components-Popup-styles___inputInVisible--v2et8 {
    display: none;
  }

.components-Popup-styles___updatePopup--cO1mT .components-Popup-styles___inputWrapper_department--uD5RY {
    flex: 49% 0 1;
    padding: 8px 0 0;
  }

.components-Popup-styles___updatePopup--cO1mT .components-Popup-styles___inputWrapper_department--uD5RY div label {
      z-index: 0;
    }

.components-Popup-styles___updatePopup--cO1mT .components-Popup-styles___selectWrapper--Q39OA {
    width: 100%;
    margin-top: 16px !important;
  }

.components-Popup-styles___updatePopup--cO1mT .components-Popup-styles___subtitleInfo--LV8kb {
    color: #6d717a;
    font-size: 15px;
    padding: 6px 0 16px;
    text-align: left;
    font-family: 'Roboto';
  }

.components-Popup-styles___updatePopup--cO1mT .components-Popup-styles___radioGroupUpdatePopup--iMUmJ {
    padding: 0;
  }

.components-Popup-styles___updatePopup--cO1mT .components-Popup-styles___actionUpdatePopup--Tfpa4 {
    justify-content: flex-end;
    margin: 32px 0 22px;
    display: flex;
    margin-bottom: 0;
  }

.components-Popup-styles___updatePopup--cO1mT .components-Popup-styles___actionUpdatePopup--Tfpa4 .components-Popup-styles___button--WBGDM {
      height: 34px;
      width: 97px;
      padding: 0;
    }

.components-Popup-styles___updatePopup--cO1mT .components-Popup-styles___bigButtonSize--FTg1F {
    justify-content: flex-end;
  }

.components-Popup-styles___updatePopup--cO1mT .components-Popup-styles___bigButtonSize--FTg1F button:first-child {
      margin-right: 15px;
    }

.components-Popup-styles___updatePopup--cO1mT .components-Popup-styles___bigButtonSize--FTg1F .components-Popup-styles___button--WBGDM {
      height: 52px;
      width: 150px;
      padding: 0;
    }

.components-Popup-styles___closeIconUpdatePopup--Cw3Vw {
  position: absolute !important;
  top: 15px;
  right: 13px;
}

.components-Popup-styles___closeIconUpdatePopup--Cw3Vw svg {
    font-size: 29px !important;
  }

.components-Popup-styles___billingInformationTitle--tDwwL {
  display: flex;
  align-items: center;
  font-size: 17px;
  color: #1b2432;
  letter-spacing: 0;
  font-family: 'Roboto-Medium', 'Roboto', sans-serif;
}

.components-Popup-styles___billingInformationTitle--tDwwL svg {
    margin-right: 8px;
  }

.components-Popup-styles___borderBottom--YfZz3 {
  border-bottom: 1px solid #e0e2e6;
  padding-bottom: 22px;
}

.components-Popup-styles___phoneFields--djTmO {
  display: flex;
}

.components-Popup-styles___phoneFields--djTmO .components-Popup-styles___countryCode--oWI4I {
    margin-right: 6px;
    max-width: 192px;
  }

.components-Popup-styles___editTraveler--o7bqO {
}

.components-Popup-styles___popupButtonsContainer--xr8MU {
  border-top: 1px solid #e0e2e6;
  padding-top: 30px;
  display: flex;
  justify-content: flex-end;
}

.components-Popup-styles___popupButtonsContainer--xr8MU button {
    width: 150px;
    height: 52px;
    font-size: 17px;
  }

.components-Popup-styles___popupButtonsContainer--xr8MU button:first-child {
    border: 1px solid #318afb !important;
    border-radius: 6px;
    font-size: 17px;
    color: #318afb;
    letter-spacing: 0;
    text-align: center;
    margin-right: 15px;
  }

.components-Popup-styles___popupButtonsContainer--xr8MU .components-Popup-styles___cancelButton--db3FR {
    border: 1px solid #318afb;
    border-radius: 6px;
    font-size: 17px;
    color: #318afb;
    letter-spacing: 0;
    text-align: center;
    margin-right: 15px;
  }

.components-Popup-styles___titleStyle--acEDz {
  font-family: 'Roboto';
  font-weight: 500;
  font-size: 29px;
  color: #1b2432;
  letter-spacing: 0;
  background-color: white !important;
}

.components-Popup-styles___subtitleStyle--mR5HR {
  font-family: 'Roboto';
  font-weight: 400;
  font-size: 15px;
  color: #6d717a;
  letter-spacing: 0;
  text-align: left;
  padding-left: 32px;
  margin-top: 8px;
}

.components-Popup-styles___inputContainerCreditCard--fewqm {
  padding-bottom: 20px;
}

.components-Popup-styles___loaderContainer--t_S3v {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.2);
}

.components-Popup-styles___buttonDeleteProfile--W_dEt {
  border: 1px solid #fc3b60 !important;
  border-radius: 4px !important;
  background-color: transparent !important;
  box-shadow: none !important;
  min-width: 112px !important;
  font-size: 13px;
  color: #fc3b60 !important;
  letter-spacing: 0;
  text-align: center;
}

.components-Popup-styles___cancel--YSmEL {
  color: #318afb !important;
}

.components-Popup-styles___delete--XkE56 {
  color: white !important;
}

.components-Popup-styles___deleteButtonContainer--akllt {
  margin-bottom: 30px;
  display: flex;
  justify-content: flex-start;
}

.components-Popup-styles___deleteButtonContainerbutton--_rfNv {
    color: #fc3b60 !important;
  }

.components-Popup-styles___deleteProfileContainer--GnLmT {
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  text-align: left;
}

.components-Popup-styles___deleteProfileContainer--GnLmT .components-Popup-styles___deleteTextStyle--OYJv4 {
    font-family: 'Roboto';
    font-weight: 500;
    font-size: 15px;
    color: #fc3b60 !important;
    letter-spacing: 0;
    margin-bottom: 5px;
  }

.components-Popup-styles___deleteProfileContainer--GnLmT .components-Popup-styles___deleteTextDescStyle--KVwXU {
    font-family: 'Roboto';
    font-size: 13px;
    color: #1b2432;
    letter-spacing: 0;
    font-weight: 400;
  }

.components-Popup-styles___deleteProfileContainer--GnLmT .components-Popup-styles___bolder--nFult {
    font-weight: 600;
  }

.components-Popup-styles___buttonCont--Mucmj button:first-child {
    margin-right: 10px;
  }

.components-Popup-styles___deleteButtonStyle--x6H3e {
  background: #fc3b60 !important;
  border-radius: 4px;
  font-family: 'Roboto';
  font-size: 13px !important;
  color: #ffffff !important;
  letter-spacing: 0;
  text-align: center;
}

.components-Popup-styles___addProgram--U3UWb {
  min-width: 700px;
  margin: 32px;
  margin-top: 0;
}

.components-Popup-styles___tableCell--TJyRW {
  font-size: 15px !important;
  padding: 16px 15px 16px 15px !important;
  min-width: unset !important;
}

.components-Popup-styles___tableCell--TJyRW.components-Popup-styles___removeCell--KmGu0 {
    text-align: right;
    padding: 0 !important;
    width: 100px;
  }

.components-Popup-styles___tableCell--TJyRW.components-Popup-styles___removeCell--KmGu0 button {
      padding-left: 0;
      padding-right: 0;
    }

.components-Popup-styles___tableCell--TJyRW.components-Popup-styles___removeCell--KmGu0 .components-Popup-styles___button_more--Ss38g {
      min-width: 10px;
    }

.components-Popup-styles___tableCell--TJyRW.components-Popup-styles___removeCell--KmGu0 .components-Popup-styles___button_more--Ss38g:hover {
      background-color: transparent !important;
    }

.components-Popup-styles___tableCell--TJyRW.components-Popup-styles___removeCell--KmGu0 .components-Popup-styles___menuList--mr5_y {
      font-size: 15px;
      letter-spacing: 0;
    }

.components-Popup-styles___tableCell--TJyRW.components-Popup-styles___removeCell--KmGu0 .components-Popup-styles___menuList--mr5_y li:first-child {
        font-size: 15px;
        color: #6d717a !important;
      }

.components-Popup-styles___tableCell--TJyRW.components-Popup-styles___removeCell--KmGu0 .components-Popup-styles___menuList--mr5_y li:nth-child(3) {
        font-size: 15px;
        color: #fc3b60 !important;
      }

.components-Popup-styles___tableCell--TJyRW.components-Popup-styles___removeCell--KmGu0 .components-Popup-styles___menuList--mr5_y svg {
        margin-right: 5px;
      }

.components-Popup-styles___tableCell--TJyRW.components-Popup-styles___inputTableCell--XcQ7H {
    padding: 16px 16px 16px 0 !important;
    width: 250px;
  }

.components-Popup-styles___tableCell--TJyRW.components-Popup-styles___inputTableCell--XcQ7H > div {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }

.components-Popup-styles___tableCell--TJyRW.components-Popup-styles___buttonTableCell--nbY1h {
    padding: 16px 0 !important;
    text-align: right;
    width: 160px;
  }

.components-Popup-styles___tableCell--TJyRW .components-Popup-styles___alertMessageCont--y8Zlh {
    display: flex;
    flex-direction: column;
  }

.components-Popup-styles___tableCell--TJyRW .components-Popup-styles___alertMessageCont--y8Zlh .components-Popup-styles___alertMessage--ygel6 {
      font-family: 'Roboto-Regular';
      font-size: 11px;
      color: #fc3b60 !important;
      letter-spacing: 0;
      margin-top: 4px;
    }

.components-Popup-styles___tableCell--TJyRW .components-Popup-styles___alertMessageContInside--bMHI3 {
    display: flex;
    flex-direction: row;
    margin-top: 17px;
  }

.components-Popup-styles___tableCell--TJyRW .components-Popup-styles___alertMessageContInside--bMHI3 svg {
      margin-right: 5px !important;
    }

.components-Popup-styles___addNewTableRowProgram--vcxbN {
  margin-top: 20px;
  border-bottom: 0 !important;
}

.components-Popup-styles___borderBlue--tAchp button:first-child {
    border: 1px solid #fc3b60 !important;
  }

.components-Popup-styles___paddingRightNull--hSDeW {
  padding-right: 0 !important;
}

.components-Popup-styles___remove--eYF37 {
  border: 1px solid #fc3b60 !important;
  border-radius: 6px !important;
  font-size: 17px !important;
  color: #fc3b60 !important;
  letter-spacing: 0;
  text-align: center;
}

.components-Popup-styles___newPayment--j9VsL {
  min-width: 700px;
  padding: 32px;
  margin-top: 0;
  padding-top: 0;
}

.components-Popup-styles___newPaymentContainer--nasOd {
  display: flex;
  justify-content: space-between;
}

.components-Popup-styles___newPaymentContainer--nasOd .components-Popup-styles___inputWrapper--lIUVf {
    flex: 49% 0 1;
    padding: 8px 0 0;
  }

.components-Popup-styles___newPaymentContainer--nasOd .components-Popup-styles___inputWrapper--lIUVf .components-Popup-styles___selectWrapper--Q39OA {
      margin-top: 16px;
    }

.components-Popup-styles___wide--stWil {
  width: 200px !important;
}

.components-Popup-styles___categoriesPopup--KXb0L,
.components-Popup-styles___negotiatedPopup--thYwf {
  min-width: 700px !important;
  padding: 32px !important;
  padding-top: 22px !important;
  margin: 0 !important;
}

.components-Popup-styles___addNewHotelTableCell--Wr9ej {
  padding: 16px 0 16px 16px !important;
  width: 250px;
  border-bottom: none !important;
}

.components-Popup-styles___addNewHotelTableCell--Wr9ej > div {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

.components-Popup-styles___addNewExHotel--okEIC {
  margin-top: 14px;
  border-bottom: 0 !important;
}

.components-Popup-styles___row--XX8XM {
  display: flex;
  padding-bottom: 8px;
}

.components-Popup-styles___row--XX8XM .components-Popup-styles___inputWrapper--lIUVf {
    flex: 49% 0 1;
    padding: 8px 0 0;
  }

.components-Popup-styles___row--XX8XM .components-Popup-styles___inputWrapper--lIUVf .components-Popup-styles___selectWrapper--Q39OA {
      margin-top: 16px;
    }

.components-Popup-styles___newPaymentPopup--JXuWR button {
    width: 200px;
  }

.components-Popup-styles___newPaymentPopup--JXuWR .components-Popup-styles___selected--oCr9X div svg {
        transform: rotate(180deg);
        top: calc(50% - 8px);
        right: 11px;
        color: rgba(0, 0, 0, 0.54);
        position: absolute;
        pointer-events: none;
        font-size: 18px;
      }

.components-Popup-styles___newPaymentPopup--JXuWR .components-Popup-styles___select--Q_Wn5 div svg {
        top: calc(50% - 8px);
        right: 11px;
        color: rgba(0, 0, 0, 0.54);
        position: absolute;
        pointer-events: none;
        font-size: 18px;
      }

.components-Popup-styles___newPaymentPopup--JXuWR .components-Popup-styles___menuItem--PSfEO {
    display: flex;
    align-items: center;
  }

.components-Popup-styles___newPaymentPopup--JXuWR .components-Popup-styles___menuItem--PSfEO svg {
      border: 1px solid #dddee0;
      border-radius: 50%;
      margin-right: 5px !important;
      transform: unset !important;
      right: unset !important;
      position: unset !important;
    }

.components-Popup-styles___addFlightCreditPopup--cMze8 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  align-text: center;
  gap: 15px;
}

.components-Popup-styles___addFlightCreditPopup--cMze8 button {
    width: 200px;
    margin: 20px 5%;
  }

.components-Popup-styles___addFlightCreditPopup--cMze8 h2 {
    margin-left: 5%;
    margin-right: 5%;
  }

.components-Popup-styles___addFlightCreditPopup--cMze8 .components-Popup-styles___flightCreditButtonContainer--gx_TR {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

.components-Popup-styles___addFlightCreditPopup--cMze8 .components-Popup-styles___fcFieldsNotFilledError--kBnsQ {
    color: #318afb;
  }

.components-Popup-styles___addFlightCreditPopup--cMze8 .components-Popup-styles___addFlightCreditField--GIxh2 {
    width: 90%;
  }

.components-Popup-styles___addFlightCreditPopup--cMze8 .components-Popup-styles___addFlightCreditFieldSpecial--o6Pbc {
    margin-left: 5%;
    margin-right: 5%;
    width: 90%;
  }

.components-Popup-styles___boldText--AF5zK {
  font-weight: 600;
}

.components-Popup-styles___inputWrapperWithMargin--BDHwY {
  margin-right: 22px;
}

.components-Popup-styles___confirmationPopupButtons--ex4RN {
  padding: 32px;
  padding-top: 0px;
  margin: 0 !important;

  display: flex;
  justify-content: space-between;
}

.components-Popup-styles___confirmationPopupButtons--ex4RN button {
    width: 185px !important;
    height: 52px;
    font-size: 17px;
  }

.components-Popup-styles___confirmationPopupButtons--ex4RN button:first-child {
    border: 1px solid #318afb !important;
    border-radius: 6px;
    font-size: 17px;
    color: #318afb;
    letter-spacing: 0;
    text-align: center;
    margin-right: 15px;
  }

.components-Popup-styles___confirmationPopupButtons--ex4RN .components-Popup-styles___cancelButton--db3FR {
    border: 1px solid #318afb;
    border-radius: 6px;
    font-size: 17px;
    color: #318afb;
    letter-spacing: 0;
    text-align: center;
    margin-right: 15px;
  }

.components-Popup-styles___confirmationRemovePopup--E6GxC div {
    max-width: 450px;
  }

.components-Popup-styles___confirmationRemovePopup--E6GxC .components-Popup-styles___title--QHcuf {
    font-family: 'Roboto';
    font-weight: 500;
    font-size: 25px;
    color: #1b2432;
    letter-spacing: 0;
    text-align: center;
    background-color: transparent;
    padding-top: 30px;
    padding-bottom: 14px;
  }

.components-Popup-styles___confirmationRemovePopup--E6GxC .components-Popup-styles___body--PXfWk {
    font-family: 'Roboto';
    font-weight: 400;
    font-size: 15px;
    color: #6d717a;
    letter-spacing: 0;
    text-align: center;
  }

.components-Popup-styles___flagPlatformRow--zvhFw {
  padding-top: 15px;
  padding-bottom: 15px;
  display: flex;
  justify-content: space-between;

  align-items: center;
}

.components-Popup-styles___featureFlagPopup--PCfMH {
  width: 700px;
}

.components-Popup-styles___noMarginAndPadding--YjXe8 {
  margin: 0 !important;
  padding: 0 !important;
}

.components-Popup-styles___noMarginAndPadding--YjXe8 div {
    margin: 0 !important;
    padding: 0 !important;
  }

.components-Popup-styles___radiogroupFeature--U98cg {
  margin-bottom: 25px;
}

.components-Popup-styles___titleFontSizePopupConf--zqEuC {
  font-size: 25px !important;
}

.components-Popup-styles___profileDelete--I5ZDd button {
    width: 93px !important;
  }

.components-Popup-styles___confirmationPopupButtons--ex4RN {
  padding: 32px;
  padding-top: 0px;
  margin: 0 !important;

  display: flex;
  justify-content: center;
}

.components-Popup-styles___confirmationPopupButtons--ex4RN button {
    width: 185px !important;
    height: 52px;
    font-size: 17px;
  }

.components-Popup-styles___confirmationPopupButtons--ex4RN button:first-child {
    border: 1px solid #0058ff !important;
    border-radius: 6px;
    font-size: 17px;
    color: #0058ff;
    letter-spacing: 0;
    text-align: center;
    margin-right: 15px;
  }

.components-Popup-styles___confirmationPopupButtons--ex4RN button:first-child:hover {
    background: #003cc8;
    color: #ffffff;
    border: 1px solid #003cc8 !important;
  }

.components-Popup-styles___confirmationPopupButtons--ex4RN button:nth-child(2):hover {
    background: #003cc8;
    color: #ffffff;
    border: 1px solid #003cc8 !important;
  }

.components-Popup-styles___confirmationPopupButtons--ex4RN .components-Popup-styles___cancelButton--db3FR {
    border: 1px solid #0058ff;
    border-radius: 6px;
    font-size: 17px;
    background-color: white;
    letter-spacing: 0;
    text-align: center;
    color: #0058ff;
  }

.components-Popup-styles___confirmationRemovePopup--E6GxC div {
    max-width: 450px;
  }

.components-Popup-styles___confirmationRemovePopup--E6GxC .components-Popup-styles___title--QHcuf {
    font-family: 'Roboto';
    font-weight: 500;
    font-size: 25px;
    color: #1b2432;
    letter-spacing: 0;
    text-align: center;
    background-color: transparent;
    padding-top: 30px;
    padding-bottom: 14px;
  }

.components-Popup-styles___confirmationRemovePopup--E6GxC .components-Popup-styles___body--PXfWk {
    font-family: 'Roboto';
    font-weight: 400;
    font-size: 15px;
    color: #6d717a;
    letter-spacing: 0;
    text-align: center;
  }

.components-Popup-styles___titleFontSizePopupConf--zqEuC {
  font-size: 25px !important;
  max-width: 450px;
  padding-left: 32px !important;
  padding-right: 32px !important;
}

.components-Popup-styles___infoPopupButton--R9a_J button {
    width: 386px !important;
    margin-bottom: 22px;
  }

.components-Popup-styles___cardItem--kzHxc {
  color: #1b2432;
}

.components-Popup-styles___corporateMark--lytA6 {
  color: #6d717a;
  margin-left: 6px;
}

.components-Popup-styles___selectWrapperAutoSuggest--tooDS {
  margin-bottom: 8px !important;
}

.components-Popup-styles___carLoyaltyNumber--s2Hga {
  padding: 0 16px 9px 0 !important;
  width: 250px;
}

.components-Popup-styles___carLoyaltySelect--jSr0F {
  padding: 0 16px 0 0 !important;
  width: 250px;
}

.components-Popup-styles___maxWidthSubtitle--KAJM0 {
  max-width: 610px;
  font-size: 15px;
  color: #6d717a;
  letter-spacing: 0;
}

.components-Popup-styles___custombuttonStyle--QTjLo {
  height: 34px !important;
  width: 97px !important;
  color: white !important;
  background: #318afb;
  border-radius: 4px;
  font-size: 13px !important;
  color: #ffffff;
  letter-spacing: 0;
}

.components-Popup-styles___popupSubtitle--tBW0f {
  font-family: 'Roboto';
  font-size: 15px;
  color: #6d717a;
  letter-spacing: 0;
  text-align: start;
  margin-left: 10px;
  margin-top: 8px;
  margin-bottom: 25px;
}

.components-Popup-styles___inputContainerAddCompany--YBjFk {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 0 !important;
  max-width: 700px !important;
  margin-top: 0px !important;
}

.components-Popup-styles___inputContainerAddCompany--YBjFk .components-Popup-styles___inputWrapper--lIUVf {
    flex: 48% 0 1;
    padding: 8px 0 0;
  }

.components-Popup-styles___inputContainerAddCompany--YBjFk .components-Popup-styles___selectWrapper--Q39OA {
    width: 100%;
  }

.components-Popup-styles___inputContainerAddCompany--YBjFk .components-Popup-styles___actions--WG6h7 {
    width: 100%;
    border-top: 1px solid #dddee0;
    padding-top: 32px;
    margin-top: 28px;
  }

.components-Popup-styles___infoLoader--sNFyO {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  right: 0;
}

.components-Popup-styles___refundConfButtons--rgAcA {
  border-top: 1px solid #d8d8d8 !important;
  padding: 32px;
  text-align: right;
  padding-right: 0;
  padding-bottom: 0;
}

.components-Popup-styles___refundConfButtons--rgAcA .components-Popup-styles___button--WBGDM {
    width: 200px;
    height: 52px;
    font-size: 17px;
    letter-spacing: 0;
    text-align: center;
    border-radius: 6px;
  }

.components-Popup-styles___refundConfButtons--rgAcA .components-Popup-styles___button--WBGDM:first-of-type {
    margin-right: 25px;
    border: 1px solid #318afb;
  }

.components-Popup-styles___refundConfDialog--Uj7r1 {
  min-width: 636px;
  margin: 32px;
}

.components-Popup-styles___refundConfDialog--Uj7r1 .components-Popup-styles___title--QHcuf {
    padding-top: 0 !important;
    justify-content: start !important;
  }

.components-Popup-styles___refundConfDialog--Uj7r1 .components-Popup-styles___refundDesctiption--bUdIn {
    font-size: 15px;
    color: #6d717a;
    letter-spacing: 0;
    margin-bottom: 30px;
    margin-top: 10px;
    text-align: initial;
  }

.components-Popup-styles___refundConfDialog--Uj7r1 .components-Popup-styles___refundDesctiption--bUdIn span {
      font-weight: 600;
    }

.components-Popup-styles___refundConfDialog--Uj7r1 .components-Popup-styles___confRefundBody--hGUPv {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
  }

.components-Popup-styles___refundConfDialog--Uj7r1 .components-Popup-styles___textContainerRef--PVCYf {
    width: 45%;
    text-align: left;
    display: flex;
    align-items: center;
  }

.components-Popup-styles___refundConfDialog--Uj7r1 .components-Popup-styles___textContainerRef--PVCYf svg {
      margin-right: 8px;
    }

.components-Popup-styles___refundConfDialog--Uj7r1 .components-Popup-styles___dot--AWgUB {
    height: 4px;
    width: 4px;
    background-color: #6d717a;
    border-radius: 50%;
    display: inline-block;
    margin-left: 4px;
    margin-right: 4px;
    margin-bottom: 2px;
  }

.components-Popup-styles___refundConfDialog--Uj7r1 .components-Popup-styles___inputWrapper--lIUVf {
    width: 45%;
  }

.components-Popup-styles___bankAccountHeader--g4rrE {
  color: #6d717a;
  font-size: 15px;
  padding: 36px;
  padding-top: 15px;
  min-width: 700px;
  text-align: initial;
  padding-bottom: 13px;
}

.components-Popup-styles___titleBankAccount--XjOXu {
  font-size: 25px !important;
  justify-content: space-between !important;
  margin-left: 32px !important;
}

.components-Popup-styles___bankAccountContent--ucATm {
  margin: 0 32px 20px !important;
}

.components-Popup-styles___bankAccountContent--ucATm .components-Popup-styles___inputWrapper--lIUVf {
    padding-top: 2px;
  }

.components-Popup-styles___bankAccountContent--ucATm .components-Popup-styles___selectWrapper--Q39OA {
    margin-top: 16px !important;
  }

.components-Popup-styles___bankAccountPopupButtons--hIs2b {
  margin-bottom: 32px;
  display: flex;
  justify-content: flex-end;
  margin-right: 32px;
  padding-top: 32px;
  margin-left: 32px;
  border-top: 1px solid #c6c8cc !important;
}

.components-Popup-styles___bankAccountPopupButtons--hIs2b button:first-child {
    border: 1px solid #318afb !important;
    border-radius: 6px;
    font-size: 17px;
    color: #318afb;
    letter-spacing: 0;
    text-align: center;
    margin-right: 15px;
    width: 150px;
    height: 52px;
  }

.components-Popup-styles___bankAccountPopupButtons--hIs2b .components-Popup-styles___button--WBGDM {
    border-radius: 6px;
    font-size: 17px;
    letter-spacing: 0;
    text-align: center;
    width: 150px;
    height: 52px;
  }

.components-Popup-styles___userAnalyticsDescription--BK9oF {
  font-size: 15px;
  color: #6d717a;
  letter-spacing: 0;
  display: flex;
  margin-bottom: 15px;
}

.components-Popup-styles___userAnalyticsButtonCont--i0ehe {
  margin: 32px;
  margin-top: 0;
}

.components-Popup-styles___editUserAnalytics--SwWyK {
  margin-bottom: 20px;
}

.components-Popup-styles___editUserAnalyticsPopup--cSKPB {
  width: 700px;
}

.components-Popup-styles___companyDetailsActionButton--DJbEe {
  padding-top: 32px;
  border-top: 1px solid #e0e2e6;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.components-Popup-styles___companyDetailsActionButton--DJbEe button {
  background: #318afb;
  border-radius: 4px;
  font-size: 15px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 20px;
  width: 200px;
  height: 52px;
}

.components-Popup-styles___informationTitleCompany--rjajR {
  margin-left: 32px;
}

.components-Popup-styles___deleteFlagContainer--M3naT {
  display: flex;
  justify-content: space-between;
}

.components-Popup-styles___deleteFlagContainer--M3naT .components-Popup-styles___deleteFlagTextContainer--f6IKf {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

.components-Popup-styles___deleteFlagContainer--M3naT .components-Popup-styles___deleteFlagTextContainer--f6IKf .components-Popup-styles___deleteFlagText--pDNZF {
      font-family: 'Roboto-Medium', 'Roboto';
      font-size: 15px;
      color: #fc3b60 !important;
      letter-spacing: 0;
      margin-bottom: 3px;
      font-weight: 600;
    }

.components-Popup-styles___deleteFlagContainer--M3naT .components-Popup-styles___deleteFlagTextContainer--f6IKf .components-Popup-styles___deleteFlagDescription--dCXX2 {
      font-family: Roboto;
      font-size: 13px;
      color: #1b2432;
      letter-spacing: 0;
    }

.components-Popup-styles___deleteFlagContainer--M3naT .components-Popup-styles___deleteButtonContainer--akllt button {
      width: 93px !important;
      height: 32px !important;
      font-size: 13px !important;
      min-width: unset !important;
    }

.components-Popup-styles___deleteFlagContainer--M3naT .components-Popup-styles___deleteButtonContainer--akllt button:first-child {
      font-size: 13px;
      letter-spacing: 0;
      text-align: center;
      margin-right: 10px;
      border: 1px solid #318afb !important;
    }

.components-Popup-styles___deleteFlagContainer--M3naT .components-Popup-styles___deleteButtonContainer--akllt button:first-child span {
        color: #318afb !important;
      }

.components-Popup-styles___deleteFlagContainer--M3naT .components-Popup-styles___deleteButtonContainer--akllt button:nth-child(2) {
      font-size: 13px;
      letter-spacing: 0;
      text-align: center;
      background-color: #fc3b60 !important;
    }

.components-Popup-styles___deleteFlagContainer--M3naT .components-Popup-styles___deleteButtonContainer--akllt button:nth-child(2) span {
        color: white !important;
      }

.components-Popup-styles___checkboxRating--MKPUm {
  padding: 6px 12px;
}

.components-Popup-styles___checkboxRating--MKPUm svg {
    width: 18px;
    height: 18px;
    font-size: 18px;
  }

.components-Popup-styles___editUserCheck--lWWHk {
  width: 100%;
  flex: 100% !important;
  margin-top: 5px;
  margin-bottom: 10px;
  margin-left: 5px;
}

.components-Popup-styles___editUserCheck--lWWHk svg {
    width: 24px;
    height: 24px;
    font-size: 24px;
  }

.components-Popup-styles___statusUpdate--VxzW0 {
  padding: 17px 30px 0px 30px;
  width: 100%;
}

.components-Popup-styles___statusUpdate--VxzW0 .components-Popup-styles___button--WBGDM {
    width: 93px !important;
  }

.components-Popup-styles___statusUpdate--VxzW0 .components-Popup-styles___buttonTerminateProfile--KZbhy {
    border: 1px solid #fc3b60 !important;
    border-radius: 4px !important;
    background-color: transparent !important;
    box-shadow: none !important;
    min-width: 112px !important;
    font-size: 13px;
    color: #fc3b60 !important;
    letter-spacing: 0;
    text-align: center;
  }

.components-Popup-styles___statusUpdate--VxzW0 .components-Popup-styles___deleteButtonContainer--akllt {
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-start;
  }

.components-Popup-styles___statusUpdate--VxzW0 .components-Popup-styles___deleteProfileContainer--GnLmT {
    margin-bottom: 0;
    display: flex;
    justify-content: space-between;
    text-align: left;
  }

.components-Popup-styles___statusUpdate--VxzW0 .components-Popup-styles___deleteProfileContainer--GnLmT .components-Popup-styles___deleteTextStyle--OYJv4 {
      font-family: 'Roboto';
      font-weight: 500;
      font-size: 15px;
      color: #fc3b60 !important;
      letter-spacing: 0;
      margin-bottom: 5px;
    }

.components-Popup-styles___statusUpdate--VxzW0 .components-Popup-styles___deleteProfileContainer--GnLmT .components-Popup-styles___deleteTextDescStyle--KVwXU {
      font-family: 'Roboto';
      font-size: 13px;
      color: #1b2432;
      letter-spacing: 0;
      font-weight: 400;
    }

.components-Popup-styles___statusUpdate--VxzW0 .components-Popup-styles___deleteProfileContainer--GnLmT .components-Popup-styles___bolder--nFult {
      font-weight: 600;
    }

.components-Popup-styles___statusUpdate--VxzW0 .components-Popup-styles___buttonCont--Mucmj {
    display: flex;
    align-items: center;
  }

.components-Popup-styles___statusUpdate--VxzW0 .components-Popup-styles___buttonCont--Mucmj button:first-child {
      margin-right: 10px;
    }

.components-Popup-styles___statusUpdate--VxzW0 .components-Popup-styles___deleteButtonStyle--x6H3e {
    background: #fc3b60 !important;
    border-radius: 4px;
    font-family: 'Roboto';
    font-size: 13px !important;
    color: #ffffff !important;
    letter-spacing: 0;
    text-align: center;
  }

.components-Popup-styles___statusUpdate--VxzW0 {

  padding-left: 0;
  padding-right: 0;
}

.components-Popup-styles___adduser--vAhhb .components-Popup-styles___button--WBGDM:disabled {
  background-color: #318afb !important;
  opacity: 20% !important;
  color: white;
}

.components-Popup-styles___userDetailsButton--SLsIs button {
  color: white !important;
  margin: 32px;
  margin-top: 0;
  margin-right: 0 !important;
}

.components-Popup-styles___buttonContainerMargin--m92bx {
  margin-left: 32px;
  margin-right: 32px;
}

.components-Popup-styles___flightCreditModalSubtext--vmUaA {
  margin-bottom: 20px;
  text-align: left;
  color: rgba(0, 0, 0, 0.54);
}

.components-Popup-styles___statusSubtext--BIEoY {
  font-size: 12px;
  margin-bottom: 20px;
  text-align: left;
  color: rgba(0, 0, 0, 0.54);
}

.components-Popup-styles___flightCreditModalStatus--M3mG5 {
  width: 100%;
}

.components-Popup-styles___flightCreditModalStatus--M3mG5 div svg {
      top: calc(50% - 8px);
      right: 11px;
      color: rgba(0, 0, 0, 0.54);
      position: absolute;
      pointer-events: none;
      font-size: 18px;
    }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd {
    width: 500px;
    margin: 16px 32px;
  }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .MuiFormLabel-root,
    .components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .MuiInputLabel-root,
    .components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .MuiOutlinedInput-notchedOutline legend {
      text-align: left;
      transform-origin: top left;
    }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___errorSpan--bSCGx {
      text-align: left;
      color: #fc3b60 !important;
      font-size: 12px;
    }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___actionButtonContainer--WwjTA {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___headerText--nG1E0 {
      text-align: left;
      margin-top: 10px;
      margin-bottom: 0px;
      padding-bottom: 0px;
    }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___fieldContainer--OOYac {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___errorFieldContainer--qN4FI {
      display: flex;
      flex-direction: column;
    }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___subText--UgWo1 {
      font-size: 15px;
      color: #6d717a;
      letter-spacing: 0;
      text-align: left;
      margin-bottom: 20px;
    }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___statusHelp--OIF3b {
      font-size: 12px;
      color: #6d717a;
      text-align: left;
      margin: -12px 0 0;
    }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___carSection--OeMW1 {
      display: flex;
      flex-direction: column;
      gap: 16px;
      width: 100%;
    }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___sectionHeader--jkTXU {
      font-size: 14px;
      font-weight: 600;
      text-align: left;
      margin: 4px 0 0;
      padding-bottom: 4px;
      border-bottom: 1px solid #e0e0e0;
    }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___twoCol--qKQ2e {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 16px;
    }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___multilineField--xb_uA .MuiInputBase-root {
        height: auto;
        min-height: 52px;
      }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___carSection--OeMW1 input[type='date'] {
      position: relative;
      padding-right: 34px;
    }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___carSection--OeMW1 input[type='date']::-webkit-calendar-picker-indicator {
      position: absolute;
      right: 8px;
      width: 22px;
      height: 22px;
      padding: 0;
      cursor: pointer;
      transform: scale(1.3);
    }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___inlineFieldWrapper--BMoqg {
      display: flex;
      flex-direction: column;
      gap: 4px;
      justify-content: flex-end;
    }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___inlineFieldLabel--Ds6KO {
      font-size: 12px;
      color: #6d717a;
      line-height: 1.2;
      text-align: left;
      width: 100%;
    }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___timeSelectGroup--bBhqH {
      display: flex;
      align-items: center;
      gap: 4px;
    }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___timeSelectGroup--bBhqH .components-Popup-styles___MuiOutlinedInput-root--v8r9u {
        min-width: 64px;
      }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___timeSelectGroup--bBhqH .components-Popup-styles___MuiSelect-select--HX56d {
        padding: 8px 28px 8px 12px;
        font-size: 14px;
      }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___timeColon--fcUtI {
      font-weight: 600;
      color: #6d717a;
    }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___locationAccordion--DCPU2 {
      position: relative;
      border: 1px solid #e0e0e0;
      border-radius: 6px;
      margin-top: 8px;
    }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___locationAccordion--DCPU2::before {
        display: none;
      }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___locationAccordion--DCPU2 .components-Popup-styles___accTitle--Bsm_v {
        position: absolute;
        top: -9px;
        left: 10px;
        z-index: 1;
        background: #fff;
        padding: 0 4px;
        font-weight: 400;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.6);
        line-height: 1;
      }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___locationAccordion--DCPU2 .components-Popup-styles___accSummary--Jm5hl {
        color: #6d717a;
        font-size: 13px;
        align-self: center;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___locationAccordion--DCPU2 .components-Popup-styles___locGrid--LWWMM {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;
        width: 100%;
      }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___locationAccordion--DCPU2 .components-Popup-styles___locGridFull--xvV4e {
        grid-column: 1 / -1;
      }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___segmentContainer--scxfi {
      display: flex;
      flex-direction: column;
      gap: 20px;
      margin-bottom: 24px;
      width: 100%;
    }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___segmentContainer--scxfi .components-Popup-styles___segmentHeader--lOFmy {
        border-bottom: 2px solid black;
        padding-bottom: 4px;
      }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___segmentContainer--scxfi .components-Popup-styles___segmentFieldContainer--TqBlY {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        gap: 10px;
      }

.components-Popup-styles___modifyBookingDetailsPopup--VJkzs .components-Popup-styles___contentContainer--AL4Wd .components-Popup-styles___segmentContainer--scxfi .components-Popup-styles___segmentFieldContainer--TqBlY .components-Popup-styles___segmentAirlineContainer--iwv5N {
          width: 185px;
          margin-top: -16px;
        }
`, "",{"version":3,"sources":["webpack://./components/Popup/styles.pcss","<no source>"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AAuiBzB;;EAriBE;IACE,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,oBAAoB;EA2CtB;;EAzCE;MACE,SAAS;MACT,WAAW;MACX,kBAAkB;MAClB,kCAA6B;MAA7B,6BAA6B;IAK/B;;EAHE;QACE,eAAe;MACjB;;EAGF;MACE,SAAS;MACT,WAAW;MACX,kBAAkB;MAClB,kCAA6B;MAA7B,6BAA6B;IAK/B;;EAHE;QACE,eAAe;MACjB;;EAGF;MACE,SAAS;MACT,WAAW;MACX,kBAAkB;IAKpB;;EAHE;QACE,eAAe;MACjB;;EAGF;MACE,SAAS;MACT,WAAW;MACX,kBAAkB;IAKpB;;EAHE;QACE,eAAe;MACjB;;EAIJ;IACE,gBAAgB;EAClB;;EAGE;MACE,aAAa;MACb,sBAAsB;MACtB,8BAA8B;MAC9B,YAAY;MACZ,kBAAkB;MAClB,oBAAoB;MACpB,gCAAgC;IAiMlC;;EA/LE;QACE,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,gBAAgB;QAChB,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB,gBAAgB;MA4BlB;;EA1BE;UACE,mBAAmB;QACrB;;EAEA;UACE,cAAc;UACd,eAAe;QACjB;;EAEA;UACE,kBAAkB;UAClB,cAAc;QAKhB;;EAHE;YACE,gBAAgB;UAClB;;EAGF;UACE,YAAY;UACZ,iBAAiB;UACjB,kBAAkB;UAClB,WAAW;UACX,yBAAyB;UACzB,kBAAkB;QACpB;;EAGF;QACE,gBAAgB;QAChB,UAAU;MACZ;;EAEA;QACE,UAAU;MACZ;;EAEA;QACE,iBAAiB;QACjB,UAAU;MAKZ;;EAHE;UACE,yBAAyB;QAC3B;;EAGF;QACE,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,kBAAkB;MAapB;;EAXE;UACE,eAAe;UACf,cAAc;UACd,iBAAiB;QACnB;;EACA;UACE,eAAe;UACf,cAAc;UACd,iBAAiB;UACjB,aAAa;QACf;;EAGF;QACE,aAAa;QACb,mBAAmB;QACnB,2BAA2B;QAC3B,mBAAmB;MA2BrB;;EAzBE;UACE,gBAAgB;UAChB,kBAAkB;QACpB;;EAEA;UACE,eAAe;UACf,cAAc;UACd,iBAAiB;UACjB,kBAAkB;QACpB;;EAEA;UACE,YAAY;UACZ,WAAW;UACX,kBAAkB;UAClB,yBAAyB;UACzB,kBAAkB;QAOpB;;EALE;YACE,YAAY;YACZ,WAAW;YACX,kBAAkB;UACpB;;EAIJ;QACE,cAAc;MAChB;;EAEA;QACE,yBAAyB;QACzB,kBAAkB;QAClB,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;QACd,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,2BAA2B;MAa7B;;EAXE;UACE,mBAAmB;UACnB,gBAAgB;QAClB;;EACA;UACE,kBAAkB;UAClB,iBAAiB;UACjB,eAAe;UACf,cAAc;UACd,iBAAiB;QACnB;;EAGF;QACE,mBAAmB;QACnB,iBAAiB;QACjB,mBAAmB;QACnB,eAAe;QACf,eAAe;QACf,cAAc;MA6BhB;;EA3BE;UACE,aAAa;UACb,8BAA8B;UAC9B,mBAAmB;UACnB,gCAAgC;UAChC,UAAU;QAeZ;;EAbE;YACE,cAAc;UAChB;;EAGE;cACE,cAAc;YAChB;;EAEA;cACE,iBAAiB;YACnB;;EAIJ;UACE,aAAa;UACb,8BAA8B;UAC9B,mBAAmB;QACrB;;EAGF;QACE,eAAe;QACf,cAAc;QACd,iBAAiB;MACnB;;EAEA;QACE,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,kBAAkB;QAClB,aAAa;MACf;;EACA;QACE,gBAAgB;MAClB;;EAIJ;IACE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,oBAAoB;EAgCtB;;EA9BE;MACE,aAAa;MACb,eAAe;MACf,8BAA8B;IAChC;;EAEA;MACE,eAAe;MACf,mBAAmB;MACnB,aAAa;MACb,gBAAgB;IAClB;;EAEA;MACE,aAAa;MACb,eAAe;MACf,8BAA8B;MAC9B,oBAAoB;IAMtB;;EAJE;QACE,aAAa;QACb,gBAAgB;MAClB;;EAGF;MACE,YAAY;MACZ,YAAY;MACZ,UAAU;IACZ;;EAGF;IACE,sBAAsB;IACtB,gBAAgB;EAmGlB;;EAjGE;MACE,gCAAgC;IAKlC;;EAHE;QACE,qBAAqB;MACvB;;EAGF;MACE,mBAAmB;MACnB,0BAA0B;MAC1B,YAAY;MACZ,UAAU;IACZ;;EAEA;MACE,gBAAgB;MAChB,eAAe;MACf,qBAAqB;MACrB,oBAAoB;MACpB,gCAAgC;IAKlC;;EAHE;QACE,YAAY;MACd;;EAGF;MACE,aAAa;MACb,gBAAgB;MAChB,gBAAgB;MAChB,mBAAmB;MACnB,cAAc;MACd,yBAAyB;IA0B3B;;EAxBE;;QAEE,WAAW;MACb;;EAEA;QACE,eAAe;QACf,cAAc;MAKhB;;EAHE;UACE,cAAc;QAChB;;EAGF;QACE,iBAAiB;MACnB;;EAEA;QACE,yBAAyB;QACzB,yBAAyB;QACzB,YAAY;QACZ,YAAY;MACd;;EAGF;MACE,8BAA8B;MAC9B,qBAAqB;IAKvB;;EAHE;QACE,eAAe;MACjB;;EAGF;MACE,yBAAyB;IAK3B;;EAHE;QACE,eAAe;MACjB;;EAGF;MACE,yBAAyB;MACzB,gBAAgB;MAChB,aAAa;IAKf;;EAHE;QACE,eAAe;MACjB;;EAGF;MACE,eAAe;MACf,gBAAgB;MAChB,cAAc;IAChB;;EAEA;MACE,gCAAgC;IAClC;;EAIA;MACE,gBAAgB;MAChB,sBAAsB;IACxB;;EAEA;MACE,8BAA8B;IAChC;;EAEA;MACE,WAAW;MACX,2BAA2B;IAC7B;;EAGF;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAGE;MACE,eAAe;MACf,cAAc;MACd,sBAAsB;MACtB,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,cAAc;MACd,iBAAiB;IAKnB;;EAHE;QACE,gBAAgB;MAClB;;EAGF;MACE,cAAc;MACd,eAAe;MACf,aAAa;MACb,iBAAiB;MACjB,gBAAgB;MAChB,oBAAoB;IACtB;;EAEA;MACE,cAAc;MACd,eAAe;MACf,aAAa;MACb,iBAAiB;MACjB,gBAAgB;IAClB;;EAEA;MACE,sBAAsB;IAKxB;;EAHE;QACE,WAAW;MACb;;EAIJ;IACE,gBAAgB;EAClB;;EAGE;MACE,YAAY;IACd;;EAEA;MACE,mBAAmB;MACnB,iBAAiB;IACnB;;EAIA;MACE,2BAA2B;IAgB7B;;EAfE;QACE,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,gBAAgB;QAChB,iBAAiB;MACnB;;EACA;QACE,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;MAClB;;EAKF;MACE,eAAe;MACf,cAAc;MACd,sBAAsB;MACtB,aAAa;MACb,2BAA2B;MAC3B,mBAAmB;MACnB,cAAc;MACd,oBAAoB;IACtB;;EAEA;MACE,cAAc;MACd,eAAe;MACf,sBAAsB;MACtB,gBAAgB;IAClB;;EAEA;MACE,gCAAgC;MAChC,mBAAmB;MACnB,gBAAgB;IAClB;;EAEA;MACE,yBAAyB;MACzB,YAAY;IACd;;EAEA;MACE,yBAAyB;MACzB,mBAAmB;IAKrB;;EAHE;QACE,gBAAgB;MAClB;;EAGF;MACE,WAAW;MACX,gBAAgB;IAClB;;AAIJ;EACE,gBAAgB;AAwDlB;;AAtDE;IACE,eAAe;IACf,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,eAAe;EAgCjB;;AA9BE;MACE,OAAO;MACP,cAAc;MACd,eAAe;IAajB;;AAXE;QACE,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,mBAAmB;QACnB,cAAc;MAChB;;AAEA;QACE,gBAAgB;MAClB;;AAGF;MACE,eAAe;MACf,cAAc;MACd,YAAY;MACZ,yBAAyB;MACzB,kBAAkB;MAClB,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,yCAAyC;MACzC,gBAAgB;IAClB;;AAGF;IACE,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EAUrB;;AARE;MACE,mBAAmB;MACnB,gBAAgB;IAKlB;;AAHE;QACE,eAAe;MACjB;;AAKN;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AAwHvB;;AAtHE;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kDAAkD;EACpD;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,iBAAiB;EACnB;;AAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;AAEA;IACE,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,oBAAoB;EA8BtB;;AA5BE;MACE,oBAAoB;IACtB;;AAEA;MACE,iBAAiB;MACjB,mBAAmB;IACrB;;AAEA;MACE,mBAAmB;IACrB;;AAEA;MACE,6BAA6B;MAC7B,sBAAsB;MACtB,iBAAiB;IAWnB;;AATE;QACE,cAAc;QACd,eAAe;QACf,mBAAmB;MACrB;;AAEA;QACE,gBAAgB;MAClB;;AAIJ;IACE,aAAa;IACb,gBAAgB;EAClB;;AAEA;IACE,aAAa;EACf;;AACA;IACE,aAAa;IACb,gBAAgB;EAKlB;;AAHE;MACE,UAAU;IACZ;;AAGF;IACE,WAAW;IACX,2BAA2B;EAC7B;;AAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;EACvB;;AACA;IACE,UAAU;EACZ;;AAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;EAOlB;;AALE;MACE,YAAY;MACZ,WAAW;MACX,UAAU;IACZ;;AAGF;IACE,yBAAyB;EAW3B;;AATE;MACE,kBAAkB;IACpB;;AAEA;MACE,YAAY;MACZ,YAAY;MACZ,UAAU;IACZ;;AAIJ;EACE,6BAA6B;EAC7B,SAAS;EACT,WAAW;AAKb;;AAHE;IACE,0BAA0B;EAC5B;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kDAAkD;AAKpD;;AAHE;IACE,iBAAiB;EACnB;;AAGF;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;AAMf;;AAJE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;AAGF;AACA;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;EACb,yBAAyB;AA0B3B;;AAzBE;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;AAEA;IACE,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;AAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;AAGF;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,wCAAwC;EACxC,2BAA2B;EAC3B,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAI7B;;AAHE;IACE,yBAAyB;EAC3B;;AAGF;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAsBlB;;AApBE;IACE,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;EACpB;;AAEA;IACE,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;EAClB;;AAEA;IACE,gBAAgB;EAClB;;AAIA;IACE,kBAAkB;EACpB;;AAGF;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,uCAAuC;EACvC,2BAA2B;AA8E7B;;AA5EE;IACE,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;EAiCd;;AA/BE;MACE,eAAe;MACf,gBAAgB;IAClB;;AAEA;MACE,eAAe;IACjB;;AAEA;MACE,wCAAwC;IAC1C;;AAEA;MACE,eAAe;MACf,iBAAiB;IAenB;;AAbE;QACE,eAAe;QACf,yBAAyB;MAC3B;;AAEA;QACE,eAAe;QACf,yBAAyB;MAC3B;;AAEA;QACE,iBAAiB;MACnB;;AAIJ;IACE,oCAAoC;IACpC,YAAY;EAMd;;AAJE;MACE,wBAAwB;MACxB,2BAA2B;IAC7B;;AAGF;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,YAAY;EACd;;AAEA;IACE,aAAa;IACb,sBAAsB;EASxB;;AAPE;MACE,6BAA6B;MAC7B,eAAe;MACf,yBAAyB;MACzB,iBAAiB;MACjB,eAAe;IACjB;;AAGF;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAKlB;;AAHE;MACE,4BAA4B;IAC9B;;AAIJ;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAGE;IACE,oCAAoC;EACtC;;AAGF;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAUhC;;AARE;IACE,aAAa;IACb,gBAAgB;EAKlB;;AAHE;MACE,gBAAgB;IAClB;;AAIJ;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,8BAA8B;AAMhC;;AAJE;IACE,wBAAwB;IACxB,2BAA2B;EAC7B;;AAGF;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AAUrB;;AARE;IACE,aAAa;IACb,gBAAgB;EAKlB;;AAHE;MACE,gBAAgB;IAClB;;AAKF;IACE,YAAY;EACd;;AAII;QACE,yBAAyB;QACzB,oBAAoB;QACpB,WAAW;QACX,0BAA0B;QAC1B,kBAAkB;QAClB,oBAAoB;QACpB,eAAe;MACjB;;AAMA;QACE,oBAAoB;QACpB,WAAW;QACX,0BAA0B;QAC1B,kBAAkB;QAClB,oBAAoB;QACpB,eAAe;MACjB;;AAGJ;IACE,aAAa;IACb,mBAAmB;EASrB;;AARE;MACE,yBAAyB;MACzB,kBAAkB;MAClB,4BAA4B;MAC5B,2BAA2B;MAC3B,uBAAuB;MACvB,0BAA0B;IAC5B;;AAIJ;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AA6BX;;AA3BE;IACE,YAAY;IACZ,eAAe;EACjB;;AAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;AACA;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;EACb;;AACA;IACE,cAAc;EAChB;;AAEA;IACE,UAAU;EACZ;;AAEA;IACE,eAAe;IACf,gBAAgB;IAChB,UAAU;EACZ;;AAGF;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,oBAAoB;;EAEpB,aAAa;EACb,8BAA8B;AA0BhC;;AAzBE;IACE,uBAAuB;IACvB,YAAY;IACZ,eAAe;EACjB;;AAEA;IACE,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;AAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;AAIA;IACE,gBAAgB;EAClB;;AACA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;IACjB,oBAAoB;EACtB;;AAEA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;EACpB;;AAGF;EACE,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,8BAA8B;;EAE9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AAKvB;;AAJE;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;AAGF;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAGE;IACE,sBAAsB;EACxB;;AAGF;EACE,aAAa;EACb,gBAAgB;EAChB,oBAAoB;;EAEpB,aAAa;EACb,uBAAuB;AAsCzB;;AArCE;IACE,uBAAuB;IACvB,YAAY;IACZ,eAAe;EACjB;;AAEA;IACE,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;AAEA;IACE,mBAAmB;IACnB,cAAc;IACd,oCAAoC;EACtC;;AAEA;IACE,mBAAmB;IACnB,cAAc;IACd,oCAAoC;EACtC;;AAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;AAIA;IACE,gBAAgB;EAClB;;AACA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;IACjB,oBAAoB;EACtB;;AAEA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;EACpB;;AAGF;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,8BAA8B;AAChC;;AAGE;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;AAGF;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;AAiB5B;;AAfE;IACE,aAAa;IACb,gBAAgB;EAClB;;AAEA;IACE,WAAW;EACb;;AAEA;IACE,WAAW;IACX,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;EAClB;;AAGF;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,wCAAwC;EACxC,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AAcnB;;AAbE;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;AAEA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;AAGF;EACE,gBAAgB;EAChB,YAAY;AAoDd;;AAlDE;IACE,yBAAyB;IACzB,iCAAiC;EACnC;;AAEA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;EAKrB;;AAHE;MACE,gBAAgB;IAClB;;AAGF;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;AAEA;IACE,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EAKrB;;AAHE;MACE,iBAAiB;IACnB;;AAGF;IACE,WAAW;IACX,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;AAEA;IACE,UAAU;EACZ;;AAEF;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAQhC;;AAPE;IACE,gBAAgB;EAClB;;AAEA;IACE,2BAA2B;EAC7B;;AAGF;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,wCAAwC;AAsB1C;;AApBE;IACE,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,YAAY;EACd;;AAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,YAAY;EACd;;AAGF;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAqDhC;;AAnDE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EAgBzB;;AAdE;MACE,sCAAsC;MACtC,eAAe;MACf,yBAAyB;MACzB,iBAAiB;MACjB,kBAAkB;MAClB,gBAAgB;IAClB;;AACA;MACE,mBAAmB;MACnB,eAAe;MACf,cAAc;MACd,iBAAiB;IACnB;;AAIA;MACE,sBAAsB;MACtB,uBAAuB;MACvB,0BAA0B;MAC1B,2BAA2B;IAC7B;;AAEA;MACE,eAAe;MACf,iBAAiB;MACjB,kBAAkB;MAClB,kBAAkB;MAClB,oCAAoC;IAKtC;;AAHE;QACE,yBAAyB;MAC3B;;AAGF;MACE,eAAe;MACf,iBAAiB;MACjB,kBAAkB;MAClB,oCAAoC;IAItC;;AAHE;QACE,uBAAuB;MACzB;;AAKN;EACE,iBAAiB;AAOnB;;AALE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;AAGF;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAOlB;;AALE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;AAGF;EACE,2BAA2B;EAC3B,WAAW;AAwEb;;AAtEE;IACE,sBAAsB;EACxB;;AAEA;IACE,oCAAoC;IACpC,6BAA6B;IAC7B,wCAAwC;IACxC,2BAA2B;IAC3B,2BAA2B;IAC3B,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;EACpB;;AAEA;IACE,mBAAmB;IACnB,aAAa;IACb,2BAA2B;EAC7B;;AAEA;IACE,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;EAsBlB;;AApBE;MACE,qBAAqB;MACrB,gBAAgB;MAChB,eAAe;MACf,yBAAyB;MACzB,iBAAiB;MACjB,kBAAkB;IACpB;;AAEA;MACE,qBAAqB;MACrB,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,gBAAgB;IAClB;;AAEA;MACE,gBAAgB;IAClB;;AAGF;IACE,aAAa;IACb,mBAAmB;EAIrB;;AAHE;MACE,kBAAkB;IACpB;;AAGF;IACE,8BAA8B;IAC9B,kBAAkB;IAClB,qBAAqB;IACrB,0BAA0B;IAC1B,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;EACpB;;AC9wDF;;EDgxDE,eAAe;EACf;CCjxDF;;ADoxDA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AACA;EACE,WAAW;AAWb;;AATI;MACE,oBAAoB;MACpB,WAAW;MACX,0BAA0B;MAC1B,kBAAkB;MAClB,oBAAoB;MACpB,eAAe;IACjB;;AAKF;IACE,YAAY;IACZ,iBAAiB;EA+KnB;;AA9KE;;;MAGE,gBAAgB;MAChB,0BAA0B;IAC5B;;AACA;MACE,gBAAgB;MAChB,yBAAyB;MACzB,eAAe;IACjB;;AACA;MACE,aAAa;MACb,8BAA8B;MAC9B,WAAW;IACb;;AACA;MACE,gBAAgB;MAChB,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;IACrB;;AACA;MACE,WAAW;MACX,aAAa;MACb,sBAAsB;MACtB,SAAS;IACX;;AACA;MACE,aAAa;MACb,sBAAsB;IACxB;;AACA;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,gBAAgB;MAChB,mBAAmB;IACrB;;AACA;MACE,eAAe;MACf,cAAc;MACd,gBAAgB;MAChB,iBAAiB;IACnB;;AACA;MACE,aAAa;MACb,sBAAsB;MACtB,SAAS;MACT,WAAW;IACb;;AACA;MACE,eAAe;MACf,gBAAgB;MAChB,gBAAgB;MAChB,eAAe;MACf,mBAAmB;MACnB,gCAAgC;IAClC;;AACA;MACE,aAAa;MACb,8BAA8B;MAC9B,SAAS;IACX;;AAEE;QACE,YAAY;QACZ,gBAAgB;MAClB;;AAEF;MACE,kBAAkB;MAClB,mBAAmB;IACrB;;AACA;MACE,kBAAkB;MAClB,UAAU;MACV,WAAW;MACX,YAAY;MACZ,UAAU;MACV,eAAe;MACf,qBAAqB;IACvB;;AACA;MACE,aAAa;MACb,sBAAsB;MACtB,QAAQ;MACR,yBAAyB;IAC3B;;AACA;MACE,eAAe;MACf,cAAc;MACd,gBAAgB;MAChB,gBAAgB;MAChB,WAAW;IACb;;AACA;MACE,aAAa;MACb,mBAAmB;MACnB,QAAQ;IAQV;;AAPE;QACE,eAAe;MACjB;;AACA;QACE,0BAA0B;QAC1B,eAAe;MACjB;;AAEF;MACE,gBAAgB;MAChB,cAAc;IAChB;;AACA;MACE,kBAAkB;MAClB,yBAAyB;MACzB,kBAAkB;MAClB,eAAe;IAkCjB;;AAjCE;QACE,aAAa;MACf;;AACA;QACE,kBAAkB;QAClB,SAAS;QACT,UAAU;QACV,UAAU;QACV,gBAAgB;QAChB,cAAc;QACd,gBAAgB;QAChB,eAAe;QACf,yBAAyB;QACzB,cAAc;MAChB;;AACA;QACE,cAAc;QACd,eAAe;QACf,kBAAkB;QAClB,YAAY;QACZ,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;MACrB;;AACA;QACE,aAAa;QACb,8BAA8B;QAC9B,SAAS;QACT,WAAW;MACb;;AACA;QACE,mBAAmB;MACrB;;AAEF;MACE,aAAa;MACb,sBAAsB;MACtB,SAAS;MACT,mBAAmB;MACnB,WAAW;IAiBb;;AAhBE;QACE,8BAA8B;QAC9B,mBAAmB;MACrB;;AAEA;QACE,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,SAAS;MAKX;;AAJE;UACE,YAAY;UACZ,iBAAiB;QACnB","sourcesContent":[".dialogBox {\n  min-width: 540px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n\n  .title {\n    font-size: 29px;\n    color: #1b2432;\n    background-color: #fff;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    flex: 1 0 auto;\n    padding: 32px 32px 0;\n\n    .closeIcon {\n      top: 22px;\n      right: 21px;\n      position: absolute;\n      width: fit-content !important;\n\n      .svg {\n        font-size: 26px;\n      }\n    }\n\n    .closeIconCreditCard {\n      top: 22px;\n      right: 21px;\n      position: absolute;\n      width: fit-content !important;\n\n      .svg {\n        font-size: 26px;\n      }\n    }\n\n    .closeIconPopupAdd {\n      top: 22px;\n      right: 15px;\n      position: absolute;\n\n      .svg {\n        font-size: 26px;\n      }\n    }\n\n    .closeIconPopupAdd {\n      top: 22px;\n      right: 15px;\n      position: absolute;\n\n      .svg {\n        font-size: 26px;\n      }\n    }\n  }\n\n  .flightDetails {\n    min-width: 700px;\n  }\n\n  .body {\n    .container {\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      margin: 32px;\n      margin-bottom: 0px;\n      padding-bottom: 32px;\n      border-bottom: 1px solid #e0e2e6;\n\n      .destinations {\n        font-size: 25px;\n        color: #1b2432;\n        letter-spacing: 0;\n        min-width: 180px;\n        align-self: center;\n        display: flex;\n        align-items: center;\n        font-weight: 300;\n\n        p {\n          margin-bottom: 10px;\n        }\n\n        svg:first-child {\n          margin: 0 20px;\n          margin-right: 0;\n        }\n\n        .svgLoc {\n          margin-right: 15px;\n          margin-left: 0;\n\n          svg {\n            margin-left: 5px;\n          }\n        }\n\n        .line {\n          width: 497px;\n          margin-left: auto;\n          margin-right: auto;\n          height: 2px;\n          background-color: #318afb;\n          margin-bottom: 7px;\n        }\n      }\n\n      .locationFrom {\n        text-align: left;\n        width: 33%;\n      }\n\n      .time {\n        width: 33%;\n      }\n\n      .locationTo {\n        text-align: right;\n        width: 33%;\n\n        .redColor {\n          color: #fc3b60 !important;\n        }\n      }\n\n      .destinationDetails {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        margin-bottom: 7px;\n\n        .labels {\n          font-size: 15px;\n          color: #5f6670;\n          letter-spacing: 0;\n        }\n        div p {\n          font-size: 15px;\n          color: #5f6670;\n          letter-spacing: 0;\n          margin: 4px 0;\n        }\n      }\n\n      .seatDetails {\n        display: flex;\n        flex-direction: row;\n        justify-content: flex-start;\n        align-items: center;\n\n        div {\n          text-align: left;\n          margin-right: 60px;\n        }\n\n        .subTitle {\n          font-size: 15px;\n          color: #5f6670;\n          letter-spacing: 0;\n          margin-bottom: 5px;\n        }\n\n        .logo {\n          height: 32px;\n          width: 32px;\n          border-radius: 50%;\n          border: 1px solid #dddee0;\n          margin-right: 20px;\n\n          img {\n            height: 30px;\n            width: auto;\n            border-radius: 50%;\n          }\n        }\n      }\n\n      .travelerDetailsListContainer {\n        margin: 12px 0;\n      }\n\n      .travelerDetails {\n        border: 1px solid #edeeef;\n        border-radius: 4px;\n        font-size: 15px;\n        color: #1b2432;\n        letter-spacing: 0;\n        min-height: 66px;\n        margin: 12px 0;\n        display: flex;\n        align-items: center;\n        flex-direction: row;\n        justify-content: flex-start;\n\n        p {\n          margin-bottom: auto;\n          margin-top: auto;\n        }\n        .travelerName {\n          margin-right: 45px;\n          margin-left: 20px;\n          font-size: 15px;\n          color: #1b2432;\n          letter-spacing: 0;\n        }\n      }\n\n      .amenities {\n        background: #f4f4f5;\n        letter-spacing: 0;\n        border-bottom: none;\n        font-size: 13px;\n        padding: 0 16px;\n        color: #6d717a;\n\n        .amenities {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          border-bottom: 1px solid #e0e2e6;\n          padding: 0;\n\n          p {\n            margin: 16px 0;\n          }\n\n          .amenitiesIcon {\n            svg {\n              margin: 0 10px;\n            }\n\n            svg:last-of-type {\n              margin-right: 0px;\n            }\n          }\n        }\n\n        .baggage {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n        }\n      }\n\n      .details {\n        font-size: 15px;\n        color: #5f6670;\n        letter-spacing: 0;\n      }\n\n      .labels {\n        font-size: 11px;\n        color: #6d717a;\n        letter-spacing: 0;\n        margin-bottom: 8px;\n        margin-top: 0;\n      }\n      .airline {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  .rateCode {\n    min-width: 700px;\n    text-align: right;\n    padding: 0 32px;\n    padding-bottom: 32px;\n\n    .inputWrapperContainer {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: space-between;\n    }\n\n    .inputWrapper {\n      margin-top: 8px;\n      margin-bottom: 26px;\n      flex: 49% 0 1;\n      padding: 8px 0 0;\n    }\n\n    .inputContainer {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: space-between;\n      padding-bottom: 12px;\n\n      .inputWrapper {\n        flex: 49% 0 1;\n        padding: 8px 0 0;\n      }\n    }\n\n    .button {\n      height: 52px;\n      width: 150px;\n      padding: 0;\n    }\n  }\n\n  .content {\n    margin: 22px 32px 32px;\n    max-width: 537px;\n\n    .textField {\n      margin: 15px 0 10px 0 !important;\n\n      button {\n        padding: 0 !important;\n      }\n    }\n\n    .button {\n      font-weight: normal;\n      text-transform: capitalize;\n      width: 200px;\n      padding: 0;\n    }\n\n    .file-name {\n      text-align: left;\n      font-size: 14px;\n      margin: 35px 0 10px 0;\n      padding-bottom: 10px;\n      border-bottom: 1px solid #e0e2e6;\n\n      &::after {\n        content: ' ';\n      }\n    }\n\n    .actions {\n      display: flex;\n      min-width: 500px;\n      text-align: left;\n      align-items: center;\n      margin: 20px 0;\n      justify-content: flex-end;\n\n      .download-link,\n      .button {\n        flex: 1 0 0;\n      }\n\n      .download-link {\n        font-size: 13px;\n        color: #6d717a;\n\n        > a {\n          color: #318afb;\n        }\n      }\n\n      .button {\n        text-align: right;\n      }\n\n      .buttonDelete {\n        color: #fc3b60 !important;\n        border: 1px solid #fc3b60;\n        width: 142px;\n        height: 32px;\n      }\n    }\n\n    .actionsBetween {\n      justify-content: space-between;\n      align-items: flex-end;\n\n      .button {\n        flex: 0 1 200px;\n      }\n    }\n\n    .actions-right {\n      justify-content: flex-end;\n\n      .button {\n        flex: 0 1 200px;\n      }\n    }\n\n    .actionsRight {\n      justify-content: flex-end;\n      margin: 20px 0 0;\n      display: flex;\n\n      .button {\n        flex: 0 1 200px;\n      }\n    }\n\n    .error-message {\n      font-size: 12px;\n      text-align: left;\n      color: #ff0000;\n    }\n\n    .error-file-name {\n      border-bottom: 1px solid #ff0000;\n    }\n  }\n\n  &.changePasswordBox {\n    .content {\n      max-width: 336px;\n      margin: 10px 32px 32px;\n    }\n\n    .textField {\n      margin: 18px 0 14px !important;\n    }\n\n    .button {\n      width: 100%;\n      margin: 18px 0 0 !important;\n    }\n  }\n\n  .icon {\n    width: 19px;\n    height: 19px;\n  }\n\n  .eyeVisible {\n    fill: #318afb;\n  }\n\n  &.confirmationDialog {\n    .title {\n      font-size: 19px;\n      color: #1b2432;\n      background-color: #fff;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      flex: 1 0 auto;\n      padding: 32px 0 0;\n\n      &.bookingErrorPopupTitle {\n        min-width: 400px;\n      }\n    }\n\n    .body {\n      color: #6d717a;\n      font-size: 15px;\n      padding: 36px;\n      padding-top: 15px;\n      max-width: 450px;\n      padding-bottom: 48px;\n    }\n\n    .confBody {\n      color: #6d717a;\n      font-size: 15px;\n      padding: 36px;\n      padding-top: 15px;\n      max-width: 450px;\n    }\n\n    .bookingErrorPopupContent {\n      margin: 10px 20px 24px;\n\n      .bookingErrorPrimaryButton {\n        width: 100%;\n      }\n    }\n  }\n\n  &.flightDetails {\n    min-width: 540px;\n  }\n\n  &.roomDetailsDialog {\n    .content {\n      margin: 32px;\n    }\n\n    .buttonContent {\n      margin: 0 32px 32px;\n      text-align: right;\n    }\n  }\n\n  &.sendEmailConfirmation {\n    .content {\n      max-width: 637px !important;\n      .sendEmailText {\n        font-size: 15px;\n        color: #6d717a;\n        letter-spacing: 0;\n        text-align: left;\n        line-height: 38px;\n      }\n      .additionalEmailsText {\n        font-size: 15px;\n        color: #6d717a;\n        letter-spacing: 0;\n        text-align: left;\n        line-height: 38px;\n        font-weight: 600;\n      }\n    }\n  }\n\n  &.ccPopup {\n    .title {\n      font-size: 29px;\n      color: #1b2432;\n      background-color: #fff;\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      flex: 1 0 auto;\n      padding: 32px 32px 0;\n    }\n\n    .subtitle {\n      color: #6d717a;\n      font-size: 15px;\n      padding: 8px 32px 16px;\n      text-align: left;\n    }\n\n    .deleteWrapper {\n      border-bottom: 1px solid #e0e2e6;\n      padding: 8px 0 16px;\n      text-align: left;\n    }\n\n    .buttonDelete {\n      color: #fc3b60 !important;\n      height: 32px;\n    }\n\n    .actionsCC {\n      justify-content: flex-end;\n      margin: 32px 0 22px;\n\n      .button {\n        max-width: 150px;\n      }\n    }\n\n    .selectWrapper {\n      width: 100%;\n      margin-top: 24px;\n    }\n  }\n}\n\n.travelPolicyDialogBox {\n  text-align: left;\n\n  .policyRow {\n    padding: 32px 0;\n    border-bottom: 1px solid #e0e2e6;\n    display: flex;\n    align-items: center;\n    font-size: 15px;\n\n    .policyDescription {\n      flex: 1;\n      color: #6d717a;\n      font-size: 13px;\n\n      .policyTitle {\n        font-size: 15px;\n        font-weight: 500;\n        line-height: 18px;\n        padding-bottom: 6px;\n        color: #1b2432;\n      }\n\n      .policyText {\n        max-width: 300px;\n      }\n    }\n\n    .policyValue {\n      min-width: 80px;\n      padding: 0 5px;\n      height: 44px;\n      border: 1px solid #12da9f;\n      border-radius: 6px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background-color: rgba(18, 218, 159, 0.1);\n      font-weight: 700;\n    }\n  }\n\n  .content {\n    max-width: initial;\n    overflow-y: auto;\n    margin-right: 0px;\n    padding-right: 20px;\n\n    .actions-right {\n      margin: 32px 0 22px;\n      min-width: 660px;\n\n      .button {\n        flex: 0 1 144px;\n      }\n    }\n  }\n}\n\n.radioGroup {\n  padding: 0 32px;\n}\n\n.radioGroupLabel {\n  font-weight: 400;\n}\n\n.subtitlePopup {\n  max-width: 611px;\n  color: #6d717a;\n  font-size: 15px;\n  text-align: left;\n  padding: 16px 0 0 32px;\n  font-family: 'Roboto';\n  line-height: 18px;\n}\n\n.updatePopup {\n  padding: 32px;\n  max-width: 700px;\n  margin: 0 0 30px;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  font-family: 'Roboto';\n\n  .informationTitle {\n    font-size: 17px;\n    color: #1b2432;\n    letter-spacing: 0;\n    font-family: 'Roboto-Medium', 'Roboto', sans-serif;\n  }\n\n  .addMarginTop {\n    margin-top: 16px;\n  }\n\n  .billingAddress {\n    font-size: 15px;\n    color: #318afb;\n    letter-spacing: 0;\n    text-align: right;\n  }\n\n  .billingAddressContainer {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .inputContainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    padding-bottom: 22px;\n\n    &.passportInfo {\n      padding-bottom: 24px;\n    }\n\n    &.inputContainerTravelerSelection {\n      padding: 16px 0 0;\n      border-bottom: none;\n    }\n\n    &.inputContainerTravelerSelectionOpen {\n      padding: 0 0 32px 0;\n    }\n\n    &.wrapperContainer {\n      border-top: 1px solid #dddee0;\n      flex-direction: column;\n      padding-top: 32px;\n\n      .subtitle {\n        color: #6d717a;\n        font-size: 15px;\n        padding: 6px 0 16px;\n      }\n\n      .radioGroupLabel {\n        font-weight: 400;\n      }\n    }\n  }\n\n  .inputWrapper {\n    flex: 49% 0 1;\n    padding: 8px 0 0;\n  }\n\n  .inputInVisible {\n    display: none;\n  }\n  .inputWrapper_department {\n    flex: 49% 0 1;\n    padding: 8px 0 0;\n\n    div label {\n      z-index: 0;\n    }\n  }\n\n  .selectWrapper {\n    width: 100%;\n    margin-top: 16px !important;\n  }\n\n  .subtitleInfo {\n    color: #6d717a;\n    font-size: 15px;\n    padding: 6px 0 16px;\n    text-align: left;\n    font-family: 'Roboto';\n  }\n  .radioGroupUpdatePopup {\n    padding: 0;\n  }\n\n  .actionUpdatePopup {\n    justify-content: flex-end;\n    margin: 32px 0 22px;\n    display: flex;\n    margin-bottom: 0;\n\n    .button {\n      height: 34px;\n      width: 97px;\n      padding: 0;\n    }\n  }\n\n  .bigButtonSize {\n    justify-content: flex-end;\n\n    button:first-child {\n      margin-right: 15px;\n    }\n\n    .button {\n      height: 52px;\n      width: 150px;\n      padding: 0;\n    }\n  }\n}\n\n.closeIconUpdatePopup {\n  position: absolute !important;\n  top: 15px;\n  right: 13px;\n\n  svg {\n    font-size: 29px !important;\n  }\n}\n.billingInformationTitle {\n  display: flex;\n  align-items: center;\n  font-size: 17px;\n  color: #1b2432;\n  letter-spacing: 0;\n  font-family: 'Roboto-Medium', 'Roboto', sans-serif;\n\n  svg {\n    margin-right: 8px;\n  }\n}\n\n.borderBottom {\n  border-bottom: 1px solid #e0e2e6;\n  padding-bottom: 22px;\n}\n\n.phoneFields {\n  display: flex;\n\n  .countryCode {\n    margin-right: 6px;\n    max-width: 192px;\n  }\n}\n\n.editTraveler {\n}\n\n.popupButtonsContainer {\n  border-top: 1px solid #e0e2e6;\n  padding-top: 30px;\n  display: flex;\n  justify-content: flex-end;\n  button {\n    width: 150px;\n    height: 52px;\n    font-size: 17px;\n  }\n\n  button:first-child {\n    border: 1px solid #318afb !important;\n    border-radius: 6px;\n    font-size: 17px;\n    color: #318afb;\n    letter-spacing: 0;\n    text-align: center;\n    margin-right: 15px;\n  }\n\n  .cancelButton {\n    border: 1px solid #318afb;\n    border-radius: 6px;\n    font-size: 17px;\n    color: #318afb;\n    letter-spacing: 0;\n    text-align: center;\n    margin-right: 15px;\n  }\n}\n\n.titleStyle {\n  font-family: 'Roboto';\n  font-weight: 500;\n  font-size: 29px;\n  color: #1b2432;\n  letter-spacing: 0;\n  background-color: white !important;\n}\n\n.subtitleStyle {\n  font-family: 'Roboto';\n  font-weight: 400;\n  font-size: 15px;\n  color: #6d717a;\n  letter-spacing: 0;\n  text-align: left;\n  padding-left: 32px;\n  margin-top: 8px;\n}\n\n.inputContainerCreditCard {\n  padding-bottom: 20px;\n}\n\n.loaderContainer {\n  position: fixed;\n  left: 0px;\n  top: 0px;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.buttonDeleteProfile {\n  border: 1px solid #fc3b60 !important;\n  border-radius: 4px !important;\n  background-color: transparent !important;\n  box-shadow: none !important;\n  min-width: 112px !important;\n  font-size: 13px;\n  color: #fc3b60 !important;\n  letter-spacing: 0;\n  text-align: center;\n}\n\n.cancel {\n  color: #318afb !important;\n}\n\n.delete {\n  color: white !important;\n}\n\n.deleteButtonContainer {\n  margin-bottom: 30px;\n  display: flex;\n  justify-content: flex-start;\n  &button {\n    color: #fc3b60 !important;\n  }\n}\n\n.deleteProfileContainer {\n  margin-bottom: 30px;\n  display: flex;\n  justify-content: space-between;\n  text-align: left;\n\n  .deleteTextStyle {\n    font-family: 'Roboto';\n    font-weight: 500;\n    font-size: 15px;\n    color: #fc3b60 !important;\n    letter-spacing: 0;\n    margin-bottom: 5px;\n  }\n\n  .deleteTextDescStyle {\n    font-family: 'Roboto';\n    font-size: 13px;\n    color: #1b2432;\n    letter-spacing: 0;\n    font-weight: 400;\n  }\n\n  .bolder {\n    font-weight: 600;\n  }\n}\n\n.buttonCont {\n  button:first-child {\n    margin-right: 10px;\n  }\n}\n\n.deleteButtonStyle {\n  background: #fc3b60 !important;\n  border-radius: 4px;\n  font-family: 'Roboto';\n  font-size: 13px !important;\n  color: #ffffff !important;\n  letter-spacing: 0;\n  text-align: center;\n}\n\n.addProgram {\n  min-width: 700px;\n  margin: 32px;\n  margin-top: 0;\n}\n\n.tableCell {\n  font-size: 15px !important;\n  padding: 16px 15px 16px 15px !important;\n  min-width: unset !important;\n\n  &.removeCell {\n    text-align: right;\n    padding: 0 !important;\n    width: 100px;\n\n    button {\n      padding-left: 0;\n      padding-right: 0;\n    }\n\n    .button_more {\n      min-width: 10px;\n    }\n\n    .button_more:hover {\n      background-color: transparent !important;\n    }\n\n    .menuList {\n      font-size: 15px;\n      letter-spacing: 0;\n\n      li:first-child {\n        font-size: 15px;\n        color: #6d717a !important;\n      }\n\n      li:nth-child(3) {\n        font-size: 15px;\n        color: #fc3b60 !important;\n      }\n\n      svg {\n        margin-right: 5px;\n      }\n    }\n  }\n\n  &.inputTableCell {\n    padding: 16px 16px 16px 0 !important;\n    width: 250px;\n\n    > div {\n      margin-top: 0 !important;\n      margin-bottom: 0 !important;\n    }\n  }\n\n  &.buttonTableCell {\n    padding: 16px 0 !important;\n    text-align: right;\n    width: 160px;\n  }\n\n  .alertMessageCont {\n    display: flex;\n    flex-direction: column;\n\n    .alertMessage {\n      font-family: 'Roboto-Regular';\n      font-size: 11px;\n      color: #fc3b60 !important;\n      letter-spacing: 0;\n      margin-top: 4px;\n    }\n  }\n\n  .alertMessageContInside {\n    display: flex;\n    flex-direction: row;\n    margin-top: 17px;\n\n    svg {\n      margin-right: 5px !important;\n    }\n  }\n}\n\n.addNewTableRowProgram {\n  margin-top: 20px;\n  border-bottom: 0 !important;\n}\n\n.borderBlue {\n  button:first-child {\n    border: 1px solid #fc3b60 !important;\n  }\n}\n\n.paddingRightNull {\n  padding-right: 0 !important;\n}\n\n.remove {\n  border: 1px solid #fc3b60 !important;\n  border-radius: 6px !important;\n  font-size: 17px !important;\n  color: #fc3b60 !important;\n  letter-spacing: 0;\n  text-align: center;\n}\n\n.newPayment {\n  min-width: 700px;\n  padding: 32px;\n  margin-top: 0;\n  padding-top: 0;\n}\n\n.newPaymentContainer {\n  display: flex;\n  justify-content: space-between;\n\n  .inputWrapper {\n    flex: 49% 0 1;\n    padding: 8px 0 0;\n\n    .selectWrapper {\n      margin-top: 16px;\n    }\n  }\n}\n\n.wide {\n  width: 200px !important;\n}\n\n.categoriesPopup,\n.negotiatedPopup {\n  min-width: 700px !important;\n  padding: 32px !important;\n  padding-top: 22px !important;\n  margin: 0 !important;\n}\n\n.addNewHotelTableCell {\n  padding: 16px 0 16px 16px !important;\n  width: 250px;\n  border-bottom: none !important;\n\n  > div {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n}\n\n.addNewExHotel {\n  margin-top: 14px;\n  border-bottom: 0 !important;\n}\n\n.row {\n  display: flex;\n  padding-bottom: 8px;\n\n  .inputWrapper {\n    flex: 49% 0 1;\n    padding: 8px 0 0;\n\n    .selectWrapper {\n      margin-top: 16px;\n    }\n  }\n}\n\n.newPaymentPopup {\n  button {\n    width: 200px;\n  }\n\n  .selected {\n    div {\n      svg {\n        transform: rotate(180deg);\n        top: calc(50% - 8px);\n        right: 11px;\n        color: rgba(0, 0, 0, 0.54);\n        position: absolute;\n        pointer-events: none;\n        font-size: 18px;\n      }\n    }\n  }\n\n  .select {\n    div {\n      svg {\n        top: calc(50% - 8px);\n        right: 11px;\n        color: rgba(0, 0, 0, 0.54);\n        position: absolute;\n        pointer-events: none;\n        font-size: 18px;\n      }\n    }\n  }\n  .menuItem {\n    display: flex;\n    align-items: center;\n    svg {\n      border: 1px solid #dddee0;\n      border-radius: 50%;\n      margin-right: 5px !important;\n      transform: unset !important;\n      right: unset !important;\n      position: unset !important;\n    }\n  }\n}\n\n.addFlightCreditPopup {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  align-text: center;\n  gap: 15px;\n\n  button {\n    width: 200px;\n    margin: 20px 5%;\n  }\n\n  h2 {\n    margin-left: 5%;\n    margin-right: 5%;\n  }\n  .flightCreditButtonContainer {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n  }\n  .fcFieldsNotFilledError {\n    color: #318afb;\n  }\n\n  .addFlightCreditField {\n    width: 90%;\n  }\n\n  .addFlightCreditFieldSpecial {\n    margin-left: 5%;\n    margin-right: 5%;\n    width: 90%;\n  }\n}\n\n.boldText {\n  font-weight: 600;\n}\n\n.inputWrapperWithMargin {\n  margin-right: 22px;\n}\n\n.confirmationPopupButtons {\n  padding: 32px;\n  padding-top: 0px;\n  margin: 0 !important;\n\n  display: flex;\n  justify-content: space-between;\n  button {\n    width: 185px !important;\n    height: 52px;\n    font-size: 17px;\n  }\n\n  button:first-child {\n    border: 1px solid #318afb !important;\n    border-radius: 6px;\n    font-size: 17px;\n    color: #318afb;\n    letter-spacing: 0;\n    text-align: center;\n    margin-right: 15px;\n  }\n\n  .cancelButton {\n    border: 1px solid #318afb;\n    border-radius: 6px;\n    font-size: 17px;\n    color: #318afb;\n    letter-spacing: 0;\n    text-align: center;\n    margin-right: 15px;\n  }\n}\n\n.confirmationRemovePopup {\n  div {\n    max-width: 450px;\n  }\n  .title {\n    font-family: 'Roboto';\n    font-weight: 500;\n    font-size: 25px;\n    color: #1b2432;\n    letter-spacing: 0;\n    text-align: center;\n    background-color: transparent;\n    padding-top: 30px;\n    padding-bottom: 14px;\n  }\n\n  .body {\n    font-family: 'Roboto';\n    font-weight: 400;\n    font-size: 15px;\n    color: #6d717a;\n    letter-spacing: 0;\n    text-align: center;\n  }\n}\n\n.flagPlatformRow {\n  padding-top: 15px;\n  padding-bottom: 15px;\n  display: flex;\n  justify-content: space-between;\n\n  align-items: center;\n}\n\n.featureFlagPopup {\n  width: 700px;\n}\n\n.noMarginAndPadding {\n  margin: 0 !important;\n  padding: 0 !important;\n  div {\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n}\n\n.radiogroupFeature {\n  margin-bottom: 25px;\n}\n\n.titleFontSizePopupConf {\n  font-size: 25px !important;\n}\n\n.profileDelete {\n  button {\n    width: 93px !important;\n  }\n}\n\n.confirmationPopupButtons {\n  padding: 32px;\n  padding-top: 0px;\n  margin: 0 !important;\n\n  display: flex;\n  justify-content: center;\n  button {\n    width: 185px !important;\n    height: 52px;\n    font-size: 17px;\n  }\n\n  button:first-child {\n    border: 1px solid #0058ff !important;\n    border-radius: 6px;\n    font-size: 17px;\n    color: #0058ff;\n    letter-spacing: 0;\n    text-align: center;\n    margin-right: 15px;\n  }\n\n  button:first-child:hover {\n    background: #003cc8;\n    color: #ffffff;\n    border: 1px solid #003cc8 !important;\n  }\n\n  button:nth-child(2):hover {\n    background: #003cc8;\n    color: #ffffff;\n    border: 1px solid #003cc8 !important;\n  }\n\n  .cancelButton {\n    border: 1px solid #0058ff;\n    border-radius: 6px;\n    font-size: 17px;\n    background-color: white;\n    letter-spacing: 0;\n    text-align: center;\n    color: #0058ff;\n  }\n}\n\n.confirmationRemovePopup {\n  div {\n    max-width: 450px;\n  }\n  .title {\n    font-family: 'Roboto';\n    font-weight: 500;\n    font-size: 25px;\n    color: #1b2432;\n    letter-spacing: 0;\n    text-align: center;\n    background-color: transparent;\n    padding-top: 30px;\n    padding-bottom: 14px;\n  }\n\n  .body {\n    font-family: 'Roboto';\n    font-weight: 400;\n    font-size: 15px;\n    color: #6d717a;\n    letter-spacing: 0;\n    text-align: center;\n  }\n}\n\n.titleFontSizePopupConf {\n  font-size: 25px !important;\n  max-width: 450px;\n  padding-left: 32px !important;\n  padding-right: 32px !important;\n}\n\n.infoPopupButton {\n  button {\n    width: 386px !important;\n    margin-bottom: 22px;\n  }\n}\n\n.cardItem {\n  color: #1b2432;\n}\n\n.corporateMark {\n  color: #6d717a;\n  margin-left: 6px;\n}\n\n.selectWrapperAutoSuggest {\n  margin-bottom: 8px !important;\n}\n\n.carLoyaltyNumber {\n  padding: 0 16px 9px 0 !important;\n  width: 250px;\n}\n\n.carLoyaltySelect {\n  padding: 0 16px 0 0 !important;\n  width: 250px;\n}\n\n.maxWidthSubtitle {\n  max-width: 610px;\n  font-size: 15px;\n  color: #6d717a;\n  letter-spacing: 0;\n}\n\n.custombuttonStyle {\n  height: 34px !important;\n  width: 97px !important;\n  color: white !important;\n  background: #318afb;\n  border-radius: 4px;\n  font-size: 13px !important;\n  color: #ffffff;\n  letter-spacing: 0;\n}\n\n.popupSubtitle {\n  font-family: 'Roboto';\n  font-size: 15px;\n  color: #6d717a;\n  letter-spacing: 0;\n  text-align: start;\n  margin-left: 10px;\n  margin-top: 8px;\n  margin-bottom: 25px;\n}\n\n.inputContainerAddCompany {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding-bottom: 0 !important;\n  max-width: 700px !important;\n  margin-top: 0px !important;\n\n  .inputWrapper {\n    flex: 48% 0 1;\n    padding: 8px 0 0;\n  }\n\n  .selectWrapper {\n    width: 100%;\n  }\n\n  .actions {\n    width: 100%;\n    border-top: 1px solid #dddee0;\n    padding-top: 32px;\n    margin-top: 28px;\n  }\n}\n\n.infoLoader {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  right: 0;\n}\n\n.refundConfButtons {\n  border-top: 1px solid #d8d8d8 !important;\n  padding: 32px;\n  text-align: right;\n  padding-right: 0;\n  padding-bottom: 0;\n  .button {\n    width: 200px;\n    height: 52px;\n    font-size: 17px;\n    letter-spacing: 0;\n    text-align: center;\n    border-radius: 6px;\n  }\n\n  .button:first-of-type {\n    margin-right: 25px;\n    border: 1px solid #318afb;\n  }\n}\n\n.refundConfDialog {\n  min-width: 636px;\n  margin: 32px;\n\n  .title {\n    padding-top: 0 !important;\n    justify-content: start !important;\n  }\n\n  .refundDesctiption {\n    font-size: 15px;\n    color: #6d717a;\n    letter-spacing: 0;\n    margin-bottom: 30px;\n    margin-top: 10px;\n    text-align: initial;\n\n    span {\n      font-weight: 600;\n    }\n  }\n\n  .confRefundBody {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 25px;\n  }\n\n  .textContainerRef {\n    width: 45%;\n    text-align: left;\n    display: flex;\n    align-items: center;\n\n    svg {\n      margin-right: 8px;\n    }\n  }\n\n  .dot {\n    height: 4px;\n    width: 4px;\n    background-color: #6d717a;\n    border-radius: 50%;\n    display: inline-block;\n    margin-left: 4px;\n    margin-right: 4px;\n    margin-bottom: 2px;\n  }\n\n  .inputWrapper {\n    width: 45%;\n  }\n}\n.bankAccountHeader {\n  color: #6d717a;\n  font-size: 15px;\n  padding: 36px;\n  padding-top: 15px;\n  min-width: 700px;\n  text-align: initial;\n  padding-bottom: 13px;\n}\n\n.titleBankAccount {\n  font-size: 25px !important;\n  justify-content: space-between !important;\n  margin-left: 32px !important;\n}\n\n.bankAccountContent {\n  margin: 0 32px 20px !important;\n  .inputWrapper {\n    padding-top: 2px;\n  }\n\n  .selectWrapper {\n    margin-top: 16px !important;\n  }\n}\n\n.bankAccountPopupButtons {\n  margin-bottom: 32px;\n  display: flex;\n  justify-content: flex-end;\n  margin-right: 32px;\n  padding-top: 32px;\n  margin-left: 32px;\n  border-top: 1px solid #c6c8cc !important;\n\n  button:first-child {\n    border: 1px solid #318afb !important;\n    border-radius: 6px;\n    font-size: 17px;\n    color: #318afb;\n    letter-spacing: 0;\n    text-align: center;\n    margin-right: 15px;\n    width: 150px;\n    height: 52px;\n  }\n\n  .button {\n    border-radius: 6px;\n    font-size: 17px;\n    letter-spacing: 0;\n    text-align: center;\n    width: 150px;\n    height: 52px;\n  }\n}\n\n.userAnalyticsDescription {\n  font-size: 15px;\n  color: #6d717a;\n  letter-spacing: 0;\n  display: flex;\n  margin-bottom: 15px;\n}\n\n.userAnalyticsButtonCont {\n  margin: 32px;\n  margin-top: 0;\n}\n\n.editUserAnalytics {\n  margin-bottom: 20px;\n}\n\n.editUserAnalyticsPopup {\n  width: 700px;\n}\n\n.companyDetailsActionButton {\n  padding-top: 32px;\n  border-top: 1px solid #e0e2e6;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n.companyDetailsActionButton button {\n  background: #318afb;\n  border-radius: 4px;\n  font-size: 15px;\n  color: #ffffff;\n  letter-spacing: 0;\n  line-height: 20px;\n  width: 200px;\n  height: 52px;\n}\n\n.informationTitleCompany {\n  margin-left: 32px;\n}\n\n.deleteFlagContainer {\n  display: flex;\n  justify-content: space-between;\n\n  .deleteFlagTextContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n\n    .deleteFlagText {\n      font-family: 'Roboto-Medium', 'Roboto';\n      font-size: 15px;\n      color: #fc3b60 !important;\n      letter-spacing: 0;\n      margin-bottom: 3px;\n      font-weight: 600;\n    }\n    .deleteFlagDescription {\n      font-family: Roboto;\n      font-size: 13px;\n      color: #1b2432;\n      letter-spacing: 0;\n    }\n  }\n\n  .deleteButtonContainer {\n    button {\n      width: 93px !important;\n      height: 32px !important;\n      font-size: 13px !important;\n      min-width: unset !important;\n    }\n\n    button:first-child {\n      font-size: 13px;\n      letter-spacing: 0;\n      text-align: center;\n      margin-right: 10px;\n      border: 1px solid #318afb !important;\n\n      span {\n        color: #318afb !important;\n      }\n    }\n\n    button:nth-child(2) {\n      font-size: 13px;\n      letter-spacing: 0;\n      text-align: center;\n      background-color: #fc3b60 !important;\n      span {\n        color: white !important;\n      }\n    }\n  }\n}\n\n.checkboxRating {\n  padding: 6px 12px;\n\n  svg {\n    width: 18px;\n    height: 18px;\n    font-size: 18px;\n  }\n}\n\n.editUserCheck {\n  width: 100%;\n  flex: 100% !important;\n  margin-top: 5px;\n  margin-bottom: 10px;\n  margin-left: 5px;\n\n  svg {\n    width: 24px;\n    height: 24px;\n    font-size: 24px;\n  }\n}\n\n.statusUpdate {\n  padding: 17px 30px 0px 30px;\n  width: 100%;\n\n  .button {\n    width: 93px !important;\n  }\n\n  .buttonTerminateProfile {\n    border: 1px solid #fc3b60 !important;\n    border-radius: 4px !important;\n    background-color: transparent !important;\n    box-shadow: none !important;\n    min-width: 112px !important;\n    font-size: 13px;\n    color: #fc3b60 !important;\n    letter-spacing: 0;\n    text-align: center;\n  }\n\n  .deleteButtonContainer {\n    margin-bottom: 10px;\n    display: flex;\n    justify-content: flex-start;\n  }\n\n  .deleteProfileContainer {\n    margin-bottom: 0;\n    display: flex;\n    justify-content: space-between;\n    text-align: left;\n\n    .deleteTextStyle {\n      font-family: 'Roboto';\n      font-weight: 500;\n      font-size: 15px;\n      color: #fc3b60 !important;\n      letter-spacing: 0;\n      margin-bottom: 5px;\n    }\n\n    .deleteTextDescStyle {\n      font-family: 'Roboto';\n      font-size: 13px;\n      color: #1b2432;\n      letter-spacing: 0;\n      font-weight: 400;\n    }\n\n    .bolder {\n      font-weight: 600;\n    }\n  }\n\n  .buttonCont {\n    display: flex;\n    align-items: center;\n    button:first-child {\n      margin-right: 10px;\n    }\n  }\n\n  .deleteButtonStyle {\n    background: #fc3b60 !important;\n    border-radius: 4px;\n    font-family: 'Roboto';\n    font-size: 13px !important;\n    color: #ffffff !important;\n    letter-spacing: 0;\n    text-align: center;\n  }\n\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.adduser .button:disabled {\n  background-color: #318afb !important;\n  opacity: 20% !important;\n  color: white;\n}\n\n.userDetailsButton button {\n  color: white !important;\n  margin: 32px;\n  margin-top: 0;\n  margin-right: 0 !important;\n}\n\n.buttonContainerMargin {\n  margin-left: 32px;\n  margin-right: 32px;\n}\n\n.flightCreditModalSubtext {\n  margin-bottom: 20px;\n  text-align: left;\n  color: rgba(0, 0, 0, 0.54);\n}\n.statusSubtext {\n  font-size: 12px;\n  margin-bottom: 20px;\n  text-align: left;\n  color: rgba(0, 0, 0, 0.54);\n}\n.flightCreditModalStatus {\n  width: 100%;\n  div {\n    svg {\n      top: calc(50% - 8px);\n      right: 11px;\n      color: rgba(0, 0, 0, 0.54);\n      position: absolute;\n      pointer-events: none;\n      font-size: 18px;\n    }\n  }\n}\n\n.modifyBookingDetailsPopup {\n  .contentContainer {\n    width: 500px;\n    margin: 16px 32px;\n    :global(.MuiFormLabel-root),\n    :global(.MuiInputLabel-root),\n    :global(.MuiOutlinedInput-notchedOutline legend) {\n      text-align: left;\n      transform-origin: top left;\n    }\n    .errorSpan {\n      text-align: left;\n      color: #fc3b60 !important;\n      font-size: 12px;\n    }\n    .actionButtonContainer {\n      display: flex;\n      justify-content: space-between;\n      width: 100%;\n    }\n    .headerText {\n      text-align: left;\n      margin-top: 10px;\n      margin-bottom: 0px;\n      padding-bottom: 0px;\n    }\n    .fieldContainer {\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n    }\n    .errorFieldContainer {\n      display: flex;\n      flex-direction: column;\n    }\n    .subText {\n      font-size: 15px;\n      color: #6d717a;\n      letter-spacing: 0;\n      text-align: left;\n      margin-bottom: 20px;\n    }\n    .statusHelp {\n      font-size: 12px;\n      color: #6d717a;\n      text-align: left;\n      margin: -12px 0 0;\n    }\n    .carSection {\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n      width: 100%;\n    }\n    .sectionHeader {\n      font-size: 14px;\n      font-weight: 600;\n      text-align: left;\n      margin: 4px 0 0;\n      padding-bottom: 4px;\n      border-bottom: 1px solid #e0e0e0;\n    }\n    .twoCol {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      gap: 16px;\n    }\n    .multilineField {\n      :global(.MuiInputBase-root) {\n        height: auto;\n        min-height: 52px;\n      }\n    }\n    .carSection input[type='date'] {\n      position: relative;\n      padding-right: 34px;\n    }\n    .carSection input[type='date']::-webkit-calendar-picker-indicator {\n      position: absolute;\n      right: 8px;\n      width: 22px;\n      height: 22px;\n      padding: 0;\n      cursor: pointer;\n      transform: scale(1.3);\n    }\n    .inlineFieldWrapper {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n      justify-content: flex-end;\n    }\n    .inlineFieldLabel {\n      font-size: 12px;\n      color: #6d717a;\n      line-height: 1.2;\n      text-align: left;\n      width: 100%;\n    }\n    .timeSelectGroup {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      .MuiOutlinedInput-root {\n        min-width: 64px;\n      }\n      .MuiSelect-select {\n        padding: 8px 28px 8px 12px;\n        font-size: 14px;\n      }\n    }\n    .timeColon {\n      font-weight: 600;\n      color: #6d717a;\n    }\n    .locationAccordion {\n      position: relative;\n      border: 1px solid #e0e0e0;\n      border-radius: 6px;\n      margin-top: 8px;\n      &::before {\n        display: none;\n      }\n      .accTitle {\n        position: absolute;\n        top: -9px;\n        left: 10px;\n        z-index: 1;\n        background: #fff;\n        padding: 0 4px;\n        font-weight: 400;\n        font-size: 12px;\n        color: rgba(0, 0, 0, 0.6);\n        line-height: 1;\n      }\n      .accSummary {\n        color: #6d717a;\n        font-size: 13px;\n        align-self: center;\n        min-width: 0;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n      .locGrid {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        gap: 16px;\n        width: 100%;\n      }\n      .locGridFull {\n        grid-column: 1 / -1;\n      }\n    }\n    .segmentContainer {\n      display: flex;\n      flex-direction: column;\n      gap: 20px;\n      margin-bottom: 24px;\n      width: 100%;\n      .segmentHeader {\n        border-bottom: 2px solid black;\n        padding-bottom: 4px;\n      }\n\n      .segmentFieldContainer {\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        gap: 10px;\n        .segmentAirlineContainer {\n          width: 185px;\n          margin-top: -16px;\n        }\n      }\n    }\n  }\n}\n",null],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogBox": `components-Popup-styles___dialogBox--ut1lZ`,
	"title": `components-Popup-styles___title--QHcuf`,
	"closeIcon": `components-Popup-styles___closeIcon--ONXRt`,
	"svg": `components-Popup-styles___svg--lywVS`,
	"closeIconCreditCard": `components-Popup-styles___closeIconCreditCard--jNfbX`,
	"closeIconPopupAdd": `components-Popup-styles___closeIconPopupAdd--ufESM`,
	"flightDetails": `components-Popup-styles___flightDetails--zBMOp`,
	"body": `components-Popup-styles___body--PXfWk`,
	"container": `components-Popup-styles___container--Wfpsn`,
	"destinations": `components-Popup-styles___destinations--fwfJl`,
	"svgLoc": `components-Popup-styles___svgLoc--B50qG`,
	"line": `components-Popup-styles___line--JO4Yw`,
	"locationFrom": `components-Popup-styles___locationFrom--rRN1k`,
	"time": `components-Popup-styles___time--GCELg`,
	"locationTo": `components-Popup-styles___locationTo--n6Coh`,
	"redColor": `components-Popup-styles___redColor--AEMnU`,
	"destinationDetails": `components-Popup-styles___destinationDetails--Uke9q`,
	"labels": `components-Popup-styles___labels--oAqPI`,
	"seatDetails": `components-Popup-styles___seatDetails--pJPqe`,
	"subTitle": `components-Popup-styles___subTitle--Sb7F2`,
	"logo": `components-Popup-styles___logo--max0A`,
	"travelerDetailsListContainer": `components-Popup-styles___travelerDetailsListContainer--WR93m`,
	"travelerDetails": `components-Popup-styles___travelerDetails--Z6RvL`,
	"travelerName": `components-Popup-styles___travelerName--ynl4b`,
	"amenities": `components-Popup-styles___amenities--TVrUO`,
	"amenitiesIcon": `components-Popup-styles___amenitiesIcon--QMjE5`,
	"baggage": `components-Popup-styles___baggage--TvGeH`,
	"details": `components-Popup-styles___details--f7baD`,
	"airline": `components-Popup-styles___airline--oCyto`,
	"rateCode": `components-Popup-styles___rateCode--SapHR`,
	"inputWrapperContainer": `components-Popup-styles___inputWrapperContainer--n0MLE`,
	"inputWrapper": `components-Popup-styles___inputWrapper--lIUVf`,
	"inputContainer": `components-Popup-styles___inputContainer--kkkNC`,
	"button": `components-Popup-styles___button--WBGDM`,
	"content": `components-Popup-styles___content--Kz7JJ`,
	"textField": `components-Popup-styles___textField--ThYmS`,
	"fileName": `components-Popup-styles___file-name--lm52V`,
	"actions": `components-Popup-styles___actions--WG6h7`,
	"downloadLink": `components-Popup-styles___download-link--us4lS`,
	"buttonDelete": `components-Popup-styles___buttonDelete--CgpPh`,
	"actionsBetween": `components-Popup-styles___actionsBetween--TsV4a`,
	"actionsRight": `components-Popup-styles___actions-right--Zh9QO`,
	"actionsRight": `components-Popup-styles___actionsRight--_q9Qv`,
	"errorMessage": `components-Popup-styles___error-message--Z1ATD`,
	"errorFileName": `components-Popup-styles___error-file-name--gt5Ig`,
	"changePasswordBox": `components-Popup-styles___changePasswordBox--ARWal`,
	"icon": `components-Popup-styles___icon--attu7`,
	"eyeVisible": `components-Popup-styles___eyeVisible--hU7PT`,
	"confirmationDialog": `components-Popup-styles___confirmationDialog--eLcPK`,
	"bookingErrorPopupTitle": `components-Popup-styles___bookingErrorPopupTitle--zyDzr`,
	"confBody": `components-Popup-styles___confBody--Vq1f6`,
	"bookingErrorPopupContent": `components-Popup-styles___bookingErrorPopupContent--RjBCr`,
	"bookingErrorPrimaryButton": `components-Popup-styles___bookingErrorPrimaryButton--_ArHX`,
	"roomDetailsDialog": `components-Popup-styles___roomDetailsDialog--jgT9k`,
	"buttonContent": `components-Popup-styles___buttonContent--TsnIA`,
	"sendEmailConfirmation": `components-Popup-styles___sendEmailConfirmation--gVYO_`,
	"sendEmailText": `components-Popup-styles___sendEmailText--j8LUa`,
	"additionalEmailsText": `components-Popup-styles___additionalEmailsText--YtdYY`,
	"ccPopup": `components-Popup-styles___ccPopup--yCVOX`,
	"subtitle": `components-Popup-styles___subtitle--I1rz1`,
	"deleteWrapper": `components-Popup-styles___deleteWrapper--L4V4n`,
	"actionsCc": `components-Popup-styles___actionsCC--YA3FN`,
	"selectWrapper": `components-Popup-styles___selectWrapper--Q39OA`,
	"travelPolicyDialogBox": `components-Popup-styles___travelPolicyDialogBox--fYL66`,
	"policyRow": `components-Popup-styles___policyRow--Twd5W`,
	"policyDescription": `components-Popup-styles___policyDescription--yF_Nm`,
	"policyTitle": `components-Popup-styles___policyTitle--sXwu4`,
	"policyText": `components-Popup-styles___policyText--xhKAM`,
	"policyValue": `components-Popup-styles___policyValue--vZy1m`,
	"radioGroup": `components-Popup-styles___radioGroup--ohQ3j`,
	"radioGroupLabel": `components-Popup-styles___radioGroupLabel--NlM7M`,
	"subtitlePopup": `components-Popup-styles___subtitlePopup--SshBO`,
	"updatePopup": `components-Popup-styles___updatePopup--cO1mT`,
	"informationTitle": `components-Popup-styles___informationTitle--_QZhx`,
	"addMarginTop": `components-Popup-styles___addMarginTop--QYPTY`,
	"billingAddress": `components-Popup-styles___billingAddress--NyvXN`,
	"billingAddressContainer": `components-Popup-styles___billingAddressContainer--f8wHR`,
	"passportInfo": `components-Popup-styles___passportInfo--E4UqH`,
	"inputContainerTravelerSelection": `components-Popup-styles___inputContainerTravelerSelection--D5oRQ`,
	"inputContainerTravelerSelectionOpen": `components-Popup-styles___inputContainerTravelerSelectionOpen--qEtK5`,
	"wrapperContainer": `components-Popup-styles___wrapperContainer--Gxw2v`,
	"inputInVisible": `components-Popup-styles___inputInVisible--v2et8`,
	"inputWrapperDepartment": `components-Popup-styles___inputWrapper_department--uD5RY`,
	"subtitleInfo": `components-Popup-styles___subtitleInfo--LV8kb`,
	"radioGroupUpdatePopup": `components-Popup-styles___radioGroupUpdatePopup--iMUmJ`,
	"actionUpdatePopup": `components-Popup-styles___actionUpdatePopup--Tfpa4`,
	"bigButtonSize": `components-Popup-styles___bigButtonSize--FTg1F`,
	"closeIconUpdatePopup": `components-Popup-styles___closeIconUpdatePopup--Cw3Vw`,
	"billingInformationTitle": `components-Popup-styles___billingInformationTitle--tDwwL`,
	"borderBottom": `components-Popup-styles___borderBottom--YfZz3`,
	"phoneFields": `components-Popup-styles___phoneFields--djTmO`,
	"countryCode": `components-Popup-styles___countryCode--oWI4I`,
	"editTraveler": `components-Popup-styles___editTraveler--o7bqO`,
	"popupButtonsContainer": `components-Popup-styles___popupButtonsContainer--xr8MU`,
	"cancelButton": `components-Popup-styles___cancelButton--db3FR`,
	"titleStyle": `components-Popup-styles___titleStyle--acEDz`,
	"subtitleStyle": `components-Popup-styles___subtitleStyle--mR5HR`,
	"inputContainerCreditCard": `components-Popup-styles___inputContainerCreditCard--fewqm`,
	"loaderContainer": `components-Popup-styles___loaderContainer--t_S3v`,
	"buttonDeleteProfile": `components-Popup-styles___buttonDeleteProfile--W_dEt`,
	"cancel": `components-Popup-styles___cancel--YSmEL`,
	"delete": `components-Popup-styles___delete--XkE56`,
	"deleteButtonContainer": `components-Popup-styles___deleteButtonContainer--akllt`,
	"deleteButtonContainerbutton": `components-Popup-styles___deleteButtonContainerbutton--_rfNv`,
	"deleteProfileContainer": `components-Popup-styles___deleteProfileContainer--GnLmT`,
	"deleteTextStyle": `components-Popup-styles___deleteTextStyle--OYJv4`,
	"deleteTextDescStyle": `components-Popup-styles___deleteTextDescStyle--KVwXU`,
	"bolder": `components-Popup-styles___bolder--nFult`,
	"buttonCont": `components-Popup-styles___buttonCont--Mucmj`,
	"deleteButtonStyle": `components-Popup-styles___deleteButtonStyle--x6H3e`,
	"addProgram": `components-Popup-styles___addProgram--U3UWb`,
	"tableCell": `components-Popup-styles___tableCell--TJyRW`,
	"removeCell": `components-Popup-styles___removeCell--KmGu0`,
	"buttonMore": `components-Popup-styles___button_more--Ss38g`,
	"menuList": `components-Popup-styles___menuList--mr5_y`,
	"inputTableCell": `components-Popup-styles___inputTableCell--XcQ7H`,
	"buttonTableCell": `components-Popup-styles___buttonTableCell--nbY1h`,
	"alertMessageCont": `components-Popup-styles___alertMessageCont--y8Zlh`,
	"alertMessage": `components-Popup-styles___alertMessage--ygel6`,
	"alertMessageContInside": `components-Popup-styles___alertMessageContInside--bMHI3`,
	"addNewTableRowProgram": `components-Popup-styles___addNewTableRowProgram--vcxbN`,
	"borderBlue": `components-Popup-styles___borderBlue--tAchp`,
	"paddingRightNull": `components-Popup-styles___paddingRightNull--hSDeW`,
	"remove": `components-Popup-styles___remove--eYF37`,
	"newPayment": `components-Popup-styles___newPayment--j9VsL`,
	"newPaymentContainer": `components-Popup-styles___newPaymentContainer--nasOd`,
	"wide": `components-Popup-styles___wide--stWil`,
	"categoriesPopup": `components-Popup-styles___categoriesPopup--KXb0L`,
	"negotiatedPopup": `components-Popup-styles___negotiatedPopup--thYwf`,
	"addNewHotelTableCell": `components-Popup-styles___addNewHotelTableCell--Wr9ej`,
	"addNewExHotel": `components-Popup-styles___addNewExHotel--okEIC`,
	"row": `components-Popup-styles___row--XX8XM`,
	"newPaymentPopup": `components-Popup-styles___newPaymentPopup--JXuWR`,
	"selected": `components-Popup-styles___selected--oCr9X`,
	"select": `components-Popup-styles___select--Q_Wn5`,
	"menuItem": `components-Popup-styles___menuItem--PSfEO`,
	"addFlightCreditPopup": `components-Popup-styles___addFlightCreditPopup--cMze8`,
	"flightCreditButtonContainer": `components-Popup-styles___flightCreditButtonContainer--gx_TR`,
	"fcFieldsNotFilledError": `components-Popup-styles___fcFieldsNotFilledError--kBnsQ`,
	"addFlightCreditField": `components-Popup-styles___addFlightCreditField--GIxh2`,
	"addFlightCreditFieldSpecial": `components-Popup-styles___addFlightCreditFieldSpecial--o6Pbc`,
	"boldText": `components-Popup-styles___boldText--AF5zK`,
	"inputWrapperWithMargin": `components-Popup-styles___inputWrapperWithMargin--BDHwY`,
	"confirmationPopupButtons": `components-Popup-styles___confirmationPopupButtons--ex4RN`,
	"confirmationRemovePopup": `components-Popup-styles___confirmationRemovePopup--E6GxC`,
	"flagPlatformRow": `components-Popup-styles___flagPlatformRow--zvhFw`,
	"featureFlagPopup": `components-Popup-styles___featureFlagPopup--PCfMH`,
	"noMarginAndPadding": `components-Popup-styles___noMarginAndPadding--YjXe8`,
	"radiogroupFeature": `components-Popup-styles___radiogroupFeature--U98cg`,
	"titleFontSizePopupConf": `components-Popup-styles___titleFontSizePopupConf--zqEuC`,
	"profileDelete": `components-Popup-styles___profileDelete--I5ZDd`,
	"infoPopupButton": `components-Popup-styles___infoPopupButton--R9a_J`,
	"cardItem": `components-Popup-styles___cardItem--kzHxc`,
	"corporateMark": `components-Popup-styles___corporateMark--lytA6`,
	"selectWrapperAutoSuggest": `components-Popup-styles___selectWrapperAutoSuggest--tooDS`,
	"carLoyaltyNumber": `components-Popup-styles___carLoyaltyNumber--s2Hga`,
	"carLoyaltySelect": `components-Popup-styles___carLoyaltySelect--jSr0F`,
	"maxWidthSubtitle": `components-Popup-styles___maxWidthSubtitle--KAJM0`,
	"custombuttonStyle": `components-Popup-styles___custombuttonStyle--QTjLo`,
	"popupSubtitle": `components-Popup-styles___popupSubtitle--tBW0f`,
	"inputContainerAddCompany": `components-Popup-styles___inputContainerAddCompany--YBjFk`,
	"infoLoader": `components-Popup-styles___infoLoader--sNFyO`,
	"refundConfButtons": `components-Popup-styles___refundConfButtons--rgAcA`,
	"refundConfDialog": `components-Popup-styles___refundConfDialog--Uj7r1`,
	"refundDesctiption": `components-Popup-styles___refundDesctiption--bUdIn`,
	"confRefundBody": `components-Popup-styles___confRefundBody--hGUPv`,
	"textContainerRef": `components-Popup-styles___textContainerRef--PVCYf`,
	"dot": `components-Popup-styles___dot--AWgUB`,
	"bankAccountHeader": `components-Popup-styles___bankAccountHeader--g4rrE`,
	"titleBankAccount": `components-Popup-styles___titleBankAccount--XjOXu`,
	"bankAccountContent": `components-Popup-styles___bankAccountContent--ucATm`,
	"bankAccountPopupButtons": `components-Popup-styles___bankAccountPopupButtons--hIs2b`,
	"userAnalyticsDescription": `components-Popup-styles___userAnalyticsDescription--BK9oF`,
	"userAnalyticsButtonCont": `components-Popup-styles___userAnalyticsButtonCont--i0ehe`,
	"editUserAnalytics": `components-Popup-styles___editUserAnalytics--SwWyK`,
	"editUserAnalyticsPopup": `components-Popup-styles___editUserAnalyticsPopup--cSKPB`,
	"companyDetailsActionButton": `components-Popup-styles___companyDetailsActionButton--DJbEe`,
	"informationTitleCompany": `components-Popup-styles___informationTitleCompany--rjajR`,
	"deleteFlagContainer": `components-Popup-styles___deleteFlagContainer--M3naT`,
	"deleteFlagTextContainer": `components-Popup-styles___deleteFlagTextContainer--f6IKf`,
	"deleteFlagText": `components-Popup-styles___deleteFlagText--pDNZF`,
	"deleteFlagDescription": `components-Popup-styles___deleteFlagDescription--dCXX2`,
	"checkboxRating": `components-Popup-styles___checkboxRating--MKPUm`,
	"editUserCheck": `components-Popup-styles___editUserCheck--lWWHk`,
	"statusUpdate": `components-Popup-styles___statusUpdate--VxzW0`,
	"buttonTerminateProfile": `components-Popup-styles___buttonTerminateProfile--KZbhy`,
	"adduser": `components-Popup-styles___adduser--vAhhb`,
	"userDetailsButton": `components-Popup-styles___userDetailsButton--SLsIs`,
	"buttonContainerMargin": `components-Popup-styles___buttonContainerMargin--m92bx`,
	"flightCreditModalSubtext": `components-Popup-styles___flightCreditModalSubtext--vmUaA`,
	"statusSubtext": `components-Popup-styles___statusSubtext--BIEoY`,
	"flightCreditModalStatus": `components-Popup-styles___flightCreditModalStatus--M3mG5`,
	"modifyBookingDetailsPopup": `components-Popup-styles___modifyBookingDetailsPopup--VJkzs`,
	"contentContainer": `components-Popup-styles___contentContainer--AL4Wd`,
	"errorSpan": `components-Popup-styles___errorSpan--bSCGx`,
	"actionButtonContainer": `components-Popup-styles___actionButtonContainer--WwjTA`,
	"headerText": `components-Popup-styles___headerText--nG1E0`,
	"fieldContainer": `components-Popup-styles___fieldContainer--OOYac`,
	"errorFieldContainer": `components-Popup-styles___errorFieldContainer--qN4FI`,
	"subText": `components-Popup-styles___subText--UgWo1`,
	"statusHelp": `components-Popup-styles___statusHelp--OIF3b`,
	"carSection": `components-Popup-styles___carSection--OeMW1`,
	"sectionHeader": `components-Popup-styles___sectionHeader--jkTXU`,
	"twoCol": `components-Popup-styles___twoCol--qKQ2e`,
	"multilineField": `components-Popup-styles___multilineField--xb_uA`,
	"inlineFieldWrapper": `components-Popup-styles___inlineFieldWrapper--BMoqg`,
	"inlineFieldLabel": `components-Popup-styles___inlineFieldLabel--Ds6KO`,
	"timeSelectGroup": `components-Popup-styles___timeSelectGroup--bBhqH`,
	"muiOutlinedInputRoot": `components-Popup-styles___MuiOutlinedInput-root--v8r9u`,
	"muiSelectSelect": `components-Popup-styles___MuiSelect-select--HX56d`,
	"timeColon": `components-Popup-styles___timeColon--fcUtI`,
	"locationAccordion": `components-Popup-styles___locationAccordion--DCPU2`,
	"accTitle": `components-Popup-styles___accTitle--Bsm_v`,
	"accSummary": `components-Popup-styles___accSummary--Jm5hl`,
	"locGrid": `components-Popup-styles___locGrid--LWWMM`,
	"locGridFull": `components-Popup-styles___locGridFull--xvV4e`,
	"segmentContainer": `components-Popup-styles___segmentContainer--scxfi`,
	"segmentHeader": `components-Popup-styles___segmentHeader--lOFmy`,
	"segmentFieldContainer": `components-Popup-styles___segmentFieldContainer--TqBlY`,
	"segmentAirlineContainer": `components-Popup-styles___segmentAirlineContainer--iwv5N`
};
module.exports = ___CSS_LOADER_EXPORT___;
